export const jobs = {
  // The job page, top down (tracker sj-30).
  page: {
    state: {
      done: "Erledigt",
      current: "Sie sind hier",
      upcoming: "Später",
    },
    youAreHere: "Sie sind hier",
    nextStep: {
      title: "Nächster Schritt",
      needsYou: "Braucht Sie",
      changeStatusA11y: "Status: {{status}}. Status ändern",
      giveToSomeoneElse: "Jemand anderem geben",
      nothingLeft: "Nichts mehr zu tun",
    },
    section: {
      what: "Was zu tun ist",
      where: "Wo",
      who: "Wer und wann",
      before: "Bevor Sie beginnen",
      beforeAny: "Bevor ein Teilauftrag beginnt",
      work: "Die Arbeit",
      subJobs: "Teilaufträge",
      costs: "Kosten",
      finish: "Wenn Sie fertig sind",
      atTheEnd: "Zum Schluss",
      signOff: "Abnahme",
      report: "Bericht",
      activity: "Aktivität",
    },
    change: "Ändern",
    openReport: "Bericht öffnen",
    meta: {
      doneOf: "{{done}} von {{total}}",
      updates_one: "1 Aktualisierung",
      updates_other: "{{count}} Aktualisierungen",
      estimate: "ca. {{amount}}",
    },
    summary: {
      nobodyYet: "Noch niemand",
      workDone: "Arbeit erledigt",
      signedOff: "Abgenommen",
      waitingSignOff: "Wartet auf Abnahme",
      reportLater: "Bereit, sobald die Arbeit erledigt ist",
      costsLater: "Werden erfasst, sobald die Arbeit beginnt",
      noCosts: "Keine Kosten erfasst",
      signOffLater: "Nach Abschluss der Arbeit",
    },
  },
  visits: {
    showMe: "Zeig es mir",
    title: "Besuche",
    empty: "Bisher ein Termin. Planen Sie einen weiteren Besuch, wenn die Arbeit mehr als einen Tag braucht.",
    visitNo: "Besuch {{no}}",
    arrive: "Ich bin da",
    arrived: "Ankunft erfasst",
    move: "Besuch verschieben",
    moveTitle: "Besuch {{no}} verschieben",
    moved: "Besuch verschoben",
    notes: "Notizen zum Tag",
    notesTitle: "Notizen zu Besuch {{no}}",
    notesMessage: "Was wurde bei diesem Besuch erledigt?",
    notesSaved: "Notizen gespeichert",
    cancel: "Besuch absagen",
    cancelled: "Besuch abgesagt",
    add: "Besuch planen",
    addAnother: "Weiteren Besuch planen",
    addTitle: "Besuch planen",
    addHint: "Dieselbe Person kommt an einem anderen Tag wieder. Der Auftrag wird einmal am Ende abgeschlossen.",
    added: "Besuch geplant",
    comeBack: "Ich muss wiederkommen",
    comeBackTitle: "Ich muss wiederkommen",
    comeBackHint: "Der heutige Besuch endet hier und der nächste wird geplant. Der Auftrag bleibt offen.",
    comeBackReason: "Warum müssen Sie wiederkommen?",
    todayNotes: "Was heute erledigt wurde (optional)",
    nextDay: "Nächster Besuch",
    comeBackConfirm: "Nächsten Besuch planen",
    comeBackSaved: "Nächster Besuch geplant",
    comeBackBecause: "Komme wieder: {{reason}}",
    day: "Tag",
    time: "Uhrzeit",
    save: "Speichern",
    cancelSheet: "Abbrechen",
    photosHint: "Fotos zu einem Besuch fügen Sie am selben Tag im Verlauf des Auftrags hinzu.",
    failedTitle: "Besuche konnten nicht aktualisiert werden",
    failedBody: "Bitte erneut versuchen.",
    count_one: "{{count}} Besuch",
    count_other: "{{count}} Besuche",
    status: {
      planned: "Geplant",
      arrived: "Vor Ort seit {{time}}",
      done: "Erledigt",
      cancelled: "Abgesagt",
    },
  },
  subJobs: {
    title: "Teilaufträge",
    progress: "{{done}} von {{total}} erledigt",
    toCheck: "{{n}} zu prüfen",
    empty: "Teilen Sie diesen Auftrag in kleinere Arbeiten auf, jede mit eigener Person und eigenem Datum. Dieser Auftrag wartet, bis alle erledigt sind.",
    add: "Teilauftrag hinzufügen",
    inOrder: "Der Reihe nach erledigen",
    partOf: "Teil von {{title}}",
    partOfUnknown: "Teil eines größeren Auftrags",
    unassigned: "Noch nicht zugewiesen",
    waiting: "Wartet auf den vorherigen",
    waitsFor: "Wartet, bis „{{title}}“ fertig ist.",
    cost: "Kosten der Teilaufträge bisher: {{amount}}",
    created: "Teilauftrag hinzugefügt",
    sheetTitle: "Teilauftrag hinzufügen",
    orderFailedTitle: "Reihenfolge konnte nicht geändert werden",
    orderFailedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    asOneJob: "Als einen Auftrag mit Teilaufträgen anlegen",
    asOneJobHint: "Ein Auftrag enthält alle {{n}}, jeder mit eigener Person und eigenem Datum. Er wird geschlossen, wenn alle erledigt sind.",
    parentTitle: "Befunde an {{asset}} beheben",
    parentTitleNoAsset: "Prüfbefunde beheben",
    parentBrief: "Enthält {{n}} Teilaufträge, einen je Befund. Er wartet, bis alle erledigt sind.",
    openBlocksComplete_one: "1 Teilauftrag ist noch offen. Schließen oder stornieren Sie ihn, bevor Sie diesen Auftrag abschließen.",
    openBlocksComplete_other: "{{count}} Teilaufträge sind noch offen. Schließen oder stornieren Sie sie, bevor Sie diesen Auftrag abschließen.",
    family: {
      status: {
        cancelled: "Storniert",
        signed_off: "Abgezeichnet",
        needs_you: "Braucht Sie",
        ready_to_sign_off: "Bereit zum Abzeichnen",
        in_progress: "In Arbeit",
        scheduled: "Eingeplant",
        waiting: "Wartet",
      },
      needs: {
        over_budget: "Die Kosten der Teilaufträge liegen über dem Budget des Auftrags.",
        declined: "Ein Teilauftrag wurde abgelehnt. Geben Sie ihn jemand anderem, damit der Auftrag weiterläuft.",
        cant_complete: "Jemand kann seinen Teilauftrag nicht wie geplant erledigen. Entscheiden Sie es am Teilauftrag.",
        sent_back: "Ein Teilauftrag wurde zurückgeschickt und wird nachgearbeitet.",
        late: "Ein Teilauftrag ist verspätet. Erinnern, neu zuweisen oder verschieben.",
      },
      runBy: "Geleitet von {{name}}",
      runByNobody: "Noch leitet niemand diesen Auftrag",
      changeOwner: "Leitung ändern",
      budget: "Budget {{budget}} · bisher {{spent}}",
      overBudget: "Budget um {{amount}} überschritten",
      forecast: "Voraussichtliches Ende {{date}}",
      due: "Fällig {{date}}",
      checked: "Geprüft",
      needsCheck: "Fertig: bitte prüfen",
      waitsForList: "Wartet auf {{titles}}",
      late: "Verspätet",
      showAll: "Alle {{total}} anzeigen",
      showFewer: "Weniger anzeigen",
      check: "Arbeit prüfen",
      checkedToast: "Arbeit geprüft",
      youAreHere: "Sie sind hier",
      stepOf: "Teilauftrag {{n}} von {{total}}",
      previous: "Zurück",
      next: "Weiter",
      menu: {
        title: "{{title}}",
        open: "Öffnen",
        start: "Starten",
        schedule: "Einplanen",
        reassign: "Neu zuweisen",
        remind: "Erinnern",
        pause: "Pausieren",
        skip: "Überspringen, mit Grund",
        check: "Arbeit prüfen",
        sendBack: "Zurückschicken",
        askPhotos: "Fotos anfordern",
        waitsFor: "Worauf er wartet",
        separate: "Zu eigenem Auftrag machen",
        moveTo: "Zu anderem Auftrag verschieben",
        run: "Ausführen",
        review: "Prüfen",
        family: "Auftrag",
      },
      reminded: "Erinnerung gesendet",
      remindedAlready: "Nichts zu erinnern: Er ist fertig oder niemandem zugewiesen.",
      skipTitle: "Diesen Teilauftrag überspringen?",
      skipMessage: "Er zählt für den Auftrag als erledigt und wird nie als ausgeführte Arbeit gezeigt.",
      skipPlaceholder: "Warum wird er nicht gebraucht?",
      skipConfirm: "Überspringen",
      skipped: "Teilauftrag übersprungen",
      sendBackTitle: "Zurückschicken",
      sendBackMessage: "Sagen Sie, was nachgearbeitet werden muss. {{name}} wird informiert, und die Arbeit wird nach Fertigstellung erneut geprüft.",
      sendBackPlaceholder: "Was muss nachgearbeitet werden?",
      sendBackConfirm: "Zurückschicken",
      sentBack: "Zurückgeschickt",
      askPhotosTitle: "Fotos anfordern",
      askPhotosMessage: "Sagen Sie, was Sie sehen müssen. Die Arbeit bleibt fertig, während {{name}} sie hinzufügt.",
      askPhotosPlaceholder: "Was müssen Sie sehen?",
      askPhotosConfirm: "Anfordern",
      asked: "Fotos angefordert",
      pausePlaceholder: "Warum pausiert?",
      pauseTitle: "Diesen Teilauftrag pausieren?",
      pauseConfirm: "Pausieren",
      paused: "Pausiert",
      separateTitle: "Zu eigenem Auftrag machen?",
      separateMessage: "Er verlässt diesen Auftrag und behält Person, Termine und Verlauf. Dieser Auftrag wartet nicht mehr auf ihn.",
      separateConfirm: "Eigenständig machen",
      separated: "Jetzt ein eigener Auftrag",
      signOff: "Gesamten Auftrag abzeichnen",
      signOffHint_one: "Zeichnet diesen Auftrag und seinen fertigen Teilauftrag zusammen ab.",
      signOffHint_other: "Zeichnet diesen Auftrag und seine {{count}} fertigen Teilaufträge zusammen ab.",
      signOffFor: "Bereit für {{name}} zum Abzeichnen.",
      signedOff: "Auftrag abgezeichnet",
      approvalEach: "Ich prüfe jeden Teilauftrag, sobald er fertig ist",
      approvalEachHint: "Der nächste beginnt erst nach Ihrer Prüfung. Aus: Der Genehmiger prüft alles einmal beim Abzeichnen.",
      moveAll: "Alle Termine verschieben",
      moveAllTitle: "Offene Teilaufträge verschieben",
      moveAllMessage: "Um wie viele Tage? Mit Minuszeichen vorziehen.",
      moveAllConfirm: "Verschieben",
      movedDates_one: "1 Teilauftrag verschoben",
      movedDates_other: "{{count}} Teilaufträge verschoben",
      moveDaysInvalid: "Geben Sie eine ganze Zahl von Tagen ein, z. B. 2 oder -1.",
      cancelAll: "Gesamten Auftrag stornieren",
      cancelAllTitle: "Gesamten Auftrag stornieren?",
      cancelAllMessage: "Der Auftrag und alle noch nicht fertigen Teilaufträge werden storniert, und ihre Personen werden informiert. Fertige Arbeit behält ihren Eintrag.",
      cancelAllPlaceholder: "Warum? (optional)",
      cancelAllConfirm: "Auftrag stornieren",
      cancelledAll_one: "Auftrag mit 1 offenen Teilauftrag storniert",
      cancelledAll_other: "Auftrag mit {{count}} offenen Teilaufträgen storniert",
      more: "Mehr zu diesem Auftrag",
      failedTitle: "Das hat nicht geklappt",
      failedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      waitsForTitle: "Worauf wartet „{{title}}“?",
      waitsForNone: "Auf nichts: Er kann jederzeit beginnen",
      waitsForSaved: "Gespeichert",
      addExisting: "Vorhandenen Auftrag hinzufügen",
      addExistingTitle: "Vorhandenen Auftrag hinzufügen",
      addExistingEmpty: "Kein offener Auftrag an diesem Standort kann hinzugefügt werden.",
      added: "Zu diesem Auftrag hinzugefügt",
      moveToTitle: "Zu welchem Auftrag verschieben?",
      moveToEmpty: "Kein anderer offener Auftrag an diesem Standort.",
      movedTo: "Verschoben",
      planTitle: "Teilaufträge planen",
      planHint: "Die Arbeit selbst wird in den Teilaufträgen erledigt. Dieser Auftrag schließt, wenn alle erledigt{{checked}} sind.",
      planHintChecked: " und geprüft",
      slipTitle_one: "Den Teilauftrag verschieben, der auf diesen wartet?",
      slipTitle_other: "Die {{count}} Teilaufträge verschieben, die auf diesen warten?",
      slipMessage_one: "Dieser wurde um 1 Tag {{direction}} verschoben. Verschieben Sie sie genauso, damit die Reihenfolge bleibt.",
      slipMessage_other: "Dieser wurde um {{count}} Tage {{direction}} verschoben. Verschieben Sie sie genauso, damit die Reihenfolge bleibt.",
      later: "nach hinten",
      earlier: "nach vorn",
      budgetSet: "Budget festlegen",
      budgetMessage: "Die Kosten der Teilaufträge zählen dagegen; Sie werden informiert, wenn es überschritten wird. 0 eingeben, um es zu entfernen.",
      budgetConfirm: "Speichern",
      budgetInvalid: "Geben Sie einen Betrag ein, z. B. 2500.",
      budgetSaved: "Budget gespeichert",
      timeline: {
        today: "Heute",
        forecast: "Voraussichtliches Ende",
        undated_one: "1 Teilauftrag hat noch kein Datum",
        undated_other: "{{count}} Teilaufträge haben noch kein Datum",
      },
      activityFromSubJobs: "Aus den Teilaufträgen",
      activityLabel: "Teilauftrag {{n}}: {{title}}",
      addToThisJob: "Zu diesem Auftrag hinzufügen",
      separateJob: "Eigener Auftrag",
      addedToThisJob: "Als nächster Teilauftrag hinzugefügt",
      extraWaiting: "Zusatzarbeit wartet auf Ihre Entscheidung: {{title}}",
      sentToRequester: "An den Anfragenden zur Bestätigung gesendet. Nach der Bestätigung abzeichnen.",
      waitsForRequester: "Der Anfragende bestätigt zuerst den ganzen Auftrag, dann zeichnen Sie ab.",
      template: {
        use: "Teilaufträge aus einer Vorlage hinzufügen",
        save: "Als Vorlage speichern",
        saveMessage: "Speichert diese Teilaufträge, ihre Reihenfolge und was worauf wartet. Personen, Termine und Kosten werden nicht übernommen.",
        saveConfirm: "Vorlage speichern",
        saved: "Als „{{name}}“ gespeichert",
        pickTitle: "Vorlagen",
        manage: "Verwalten",
        delete: "„{{name}}“ löschen",
        deleted: "Vorlage gelöscht",
        empty: "Noch keine Vorlagen. Speichern Sie zuerst einen Auftrag mit Teilaufträgen als Vorlage.",
        row_one: "{{name}} · 1 Schritt",
        row_other: "{{name}} · {{count}} Schritte",
        applied_one: "1 Teilauftrag hinzugefügt",
        applied_other: "{{count}} Teilaufträge hinzugefügt",
      },
      showMe: "Zeig es mir",
      mainContractor: {
        handOver: "An einen Hauptauftragnehmer übergeben",
        takeBack: "Auftrag zurücknehmen",
        takeBackTitle: "Auftrag zurücknehmen?",
        takeBackMessage: "{{name}} leitet diesen Auftrag nicht mehr, Sie leiten ihn wieder. Bereits vergebene Teilaufträge bleiben bei ihren Bearbeitern.",
        takenBack: "Sie leiten diesen Auftrag wieder",
        pickTitle: "Welcher Auftragnehmer leitet diesen Auftrag?",
        allowTitle: "Darf {{name}} auch Ihre Auftragnehmer einsetzen?",
        allowYes: "Ja, sie dürfen Teilaufträge an unsere Auftragnehmer geben",
        allowNo: "Nein, nur eigene Leute",
        handedOver: "{{name}} leitet jetzt diesen Auftrag",
        youRunIt: "Sie leiten diesen Auftrag für den Kunden. Legen Sie Teilaufträge für Ihr Team an; der Kunde gibt am Ende frei.",
        runsIt: "Ein Hauptauftragnehmer leitet diesen Auftrag. Sie geben am Ende frei.",
        nameCrew: "Team benennen",
        nameCrewMessage: "Wer aus Ihrem Team erledigt diesen Teilauftrag? Der Kunde sieht den Namen.",
        nameCrewConfirm: "Speichern",
        crewSaved: "Team gespeichert",
        crewPlaceholder: "Zum Beispiel: Lee",
        subJobTitle: "Was zu tun ist",
        brief: "Beschreibung (optional)",
        when: "Wann",
        who: "Wer erledigt es",
        ourCrew: "Unser Team",
        crewName: "Team oder Person",
        clientContractorHint: "Der Auftragnehmer des Kunden erhält den Teilauftrag und eigene Erinnerungen.",
        addAnother: "Hinzufügen und weiter",
      },
      report: {
        summary: "Übersicht",
        full: "Vollständig",
        internal: "Intern",
        forClient: "Für den Kunden",
        forClientHint: "Für den Kunden: keine Sätze oder Preise von Auftragnehmern.",
        partOf: "Teil von",
        checked: "Geprüft",
        checkedBy: "Geprüft von {{name}}",
        started: "Begonnen {{date}}",
        finished: "Fertig {{date}}",
        evidence_one: "1 Foto oder Datei",
        evidence_other: "{{count}} Fotos oder Dateien",
      },
      parts: {
        title: "Teile für den gesamten Auftrag",
        missing_one: "1 nicht vorhanden",
        missing_other: "{{count}} nicht vorhanden",
        allInHand: "Alles vorhanden",
        holdsUp: "Hält {{title}} auf",
      },
      plan: {
        asset: "Anlage",
        priority: "Priorität",
        estimate: "Schätzung",
        minutes: "Dauer (Minuten)",
        waitsFor: "Wartet auf",
        copyFrom: "Aus früherem Auftrag kopieren",
        addAnother: "Hinzufügen, dann noch einen",
        create: "Unterauftrag anlegen",
        minutesOther: "Andere Dauer (Minuten)",
        done: "Fertig",
        addedCount_one: "1 Teilauftrag hinzugefügt",
        addedCount_other: "{{count}} Teilaufträge hinzugefügt",
      },
      setup: {
        title: "Wer leitet diesen Auftrag?",
        hint: "Die Leitung plant die Teilaufträge, prüft jeden, sobald er fertig ist, und hält den Auftrag in Bewegung.",
        me: "Ich",
        current: "{{name}} (jetzt zuständig)",
        someoneElse: "Jemand anderes",
        keepOwnWork: "Die Arbeit, die schon auf diesem Auftrag liegt, als Teilauftrag 1 behalten",
        keepOwnWorkHint: "{{name}} behält diese Arbeit und wird gebeten, sie als Teilauftrag erneut anzunehmen.",
        continue: "Weiter",
      },
    },
  },
detail: {
  handoffLock: {
    assignee: "An {{name}} übergeben. Der Auftrag bleibt wie festgelegt; weisen Sie ihn neu zu oder holen Sie ihn zurück, um ihn zu ändern.",
    quotes: "Bei Auftragnehmern zur Angebotsabgabe. Der Auftrag bleibt wie festgelegt; wählen Sie ein Angebot oder schließen Sie die Anfrage, um ihn zu ändern.",
    changeTheWork: "Auftrag ändern",
    changing: "Sie ändern diesen Auftrag. {{name}} wurde informiert und wird gebeten, ihn erneut anzunehmen, sobald Sie fertig sind.",
    doneChanging: "Änderung abschließen",
    beingChangedBy: "{{name}} ändert diesen Auftrag.",
    changedSinceAccepted: "Dieser Auftrag hat sich geändert, seit Sie ihn angenommen haben. Prüfen Sie ihn und nehmen Sie ihn erneut an.",
    revisedLength: "Wie lange dauert es jetzt? (Minuten)",
    opened: "Änderung begonnen. {{name}} wurde informiert.",
    closed: "Änderung abgeschlossen. {{name}} wurde gebeten, den geänderten Auftrag anzunehmen.",
  },
  report: {
    sharePrepared: "{{title}} ist fertig.",
    shareSheetProviderHint: "Wählen Sie {{provider}} im Teilen-Menü, um diese Datei zu speichern.",
    share: {
      word: "Word teilen…",
      excel: "Excel teilen…",
      pdf: "PDF teilen…",
    },
    requestFailed: "Das hat nicht funktioniert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    exportFailed: "Die Berichtsdatei wurde nicht erstellt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    exportShared: "Bericht fertig. Er wurde zum Speichern oder Senden an das Teilen-Menü übergeben.",
    exportDownloadStarted: "Der Download hat begonnen. Sie finden ihn in Ihren Downloads.",
    exportTitle: "Auftragsabschlussbericht ({{format}})",
    brandingSettings: "Branding-Einstellungen",
    openJob: "Auftrag öffnen",
    linkCopied: "Prüflink kopiert. Fügen Sie ihn in eine E-Mail oder Nachricht ein.",
    shareToGetLink: "Teilen Sie den Bericht, um einen Link zu erhalten",
    copyReviewLink: "Prüflink kopieren",
    reviewRequested: "Prüfung angefragt",
    sharedWith: "Geteilt mit {{name}}",
    sharedReport: "Geteilter Abschlussbericht",
    signedBy: "Unterschrieben von {{name}}",
    forYourRecords: "Dieser Bericht ist für Ihre Unterlagen.",
    alreadyClosed: "Dieser Auftrag ist bereits abgeschlossen.",
    sentBackMessage: "Sie haben die Arbeit zurückgeschickt. Das Team bessert nach und teilt den Bericht erneut.",
    acceptedThanks: "Sie haben die Arbeit angenommen. Danke.",
    acceptedTeamCloses: "Sie haben die Arbeit angenommen. Das Team schließt den Auftrag jetzt ab.",
    sendBack: "Zurückschicken",
    acceptWork: "Abzeichnen",
    signOffPrompt: "Sehen Sie sich die Arbeit oben an. Wenn alles passt, unterschreiben Sie, um abzuzeichnen. Wenn nicht, tippen Sie auf Zurückschicken und sagen Sie, was nachgebessert werden muss.",
    decisionFailedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    decisionFailedTitle: "Ihre Antwort wurde nicht gesendet",
    sentBackToast: "Zurückgeschickt. Das Team wurde informiert, was nachgebessert werden muss.",
    acceptedToast: "Danke. Das Team wurde informiert, dass Sie mit der Arbeit zufrieden sind.",
  },
  contextCard: {
    untitledJob: "Auftrag ohne Titel",
    created: "Erstellt",
    createdBy: "Erstellt von {{name}}",
    showFewerDetails: "Weniger Details anzeigen",
    showMoreDetails: "Mehr Details anzeigen",
    fewerDetails: "Weniger Details",
    moreDetails: "Mehr Details",
    dueAndScheduled: "Fällig {{due}} · geplant {{scheduled}}",
    scheduled: "Geplant {{scheduled}}",
    due: "Fällig {{due}}",
    contacts: "Kontakte",
    when: "Wann",
    why: "Warum",
    what: "Was",
    where: "Wo",
    asset: "Anlage",
  },
  actionSheets: {
    failedToAskForPhotos: "Ihre Fotoanfrage wurde nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    failedToSendBack: "Der Auftrag wurde nicht zurückgeschickt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    failedToDecline: "Der Auftrag wurde nicht abgelehnt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    failedToCancel: "Der Auftrag wurde nicht storniert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    failedToPause: "Der Auftrag wurde nicht pausiert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    askedForPhotosUnnamed: "Um weitere Fotos gebeten. Der Auftrag wartet auf Ihre Prüfung.",
    askedForPhotos: "{{assignee}} um weitere Fotos gebeten. Der Auftrag wartet auf Ihre Prüfung.",
    sentBackUnnamed: "Mit Ihrer Notiz zurückgeschickt. Sie werden benachrichtigt, sobald es erneut eingereicht wird.",
    sentBack: "Mit Ihrer Notiz an {{assignee}} zurückgeschickt. Sie werden benachrichtigt, sobald es erneut eingereicht wird.",
    declined: "Auftrag abgelehnt. Die Person, die ihn zugewiesen hat, wurde benachrichtigt und kann ihn neu zuweisen.",
    cancelled: "Auftrag storniert. Er bleibt im Verlauf.",
    paused: "Auftrag pausiert. Tippen Sie auf Fortsetzen, sobald es weitergehen kann.",
  },
  fieldAssist: {
    failedTitle: "Text konnte nicht überarbeitet werden",
    revert: "Zurücksetzen",
    discard: "Verwerfen",
    accept: "Übernehmen",
    rationale: "Prüfen Sie den Text und tippen Sie dann auf Übernehmen. Bis dahin bleibt Ihr Text.",
    draftTitle: "Überarbeiteter Text",
    tidying: "Wird überarbeitet…",
    tidyUp: "Mit KI überarbeiten",
    stop: "Stopp",
    dictate: "Diktieren",
  },
  deliveryMode: {
    hint: {
      PRIVATE_QUOTES: "Fragen Sie mehrere Auftragnehmer nach einem Preis und wählen Sie einen aus.",
      DIRECT_CONTRACTOR: "Senden Sie ihn an einen Auftragnehmer, mit dem Sie schon arbeiten.",
      INTERNAL: "Jemand aus Ihrem Team erledigt die Arbeit.",
    },
    label: {
      PRIVATE_QUOTES: "Angebote einholen",
      DIRECT_CONTRACTOR: "Ein Auftragnehmer",
      INTERNAL: "Unser Team",
    },
    title: "Wer übernimmt es?",
  },
title: "Auftrag",
actionModals: {
  send: "Senden",
pauseReasons: {
waitingOnParts: "Warten auf Teile",
weatherDelay: "Wetterverzögerung",
customerRequest: "Kundenanfrage",
other: "Sonstiges",
},
declineReasons: {
scheduleConflict: "Zeitplankonflikt",
noCapacity: "Gerade zu ausgelastet",
wrongTrade: "Erfordert ein anderes Fachgebiet",
needMoreInfo: "Weitere Informationen nötig",
},
pauseTitle: "Arbeitsauftrag pausieren",
pauseReasonRequiredHint: "Grund ist erforderlich, damit das Team weiß, warum die Arbeit zurückgestellt wird.",
additionalDetailOptional: "Zusätzliches Detail (optional)",
additionalDetailPlaceholder: "z.B. Voraussichtlich nächste Woche wieder auf Lager",
cancel: "Abbrechen",
pause: "Pausieren",
cancelJobTitle: "Auftrag abbrechen",
cancelJobConfirm: "Sind Sie sicher? Dies kann nicht rückgängig gemacht werden.",
reasonOptional: "Grund (optional)",
cancellationReasonPlaceholder: "z.B. Wird nicht mehr benötigt",
back: "Zurück",
yesCancel: "Ja, abbrechen",
declineJobTitle: "Auftrag ablehnen",
declineReasonRequiredHint: "Ein Grund ist erforderlich. Die Person, die diesen Arbeitsauftrag zugewiesen hat, wird benachrichtigt.",
reasonRequired: "Grund (erforderlich)",
declineReasonPlaceholder: "z.B. Terminkonflikt, Kapazität, andere Verpflichtung",
additionalNoteOptional: "Zusätzlicher Hinweis (optional)",
additionalNotePlaceholder: "Hinweise für die Person, die den Auftrag zugewiesen hat",
declineJob: "Ablehnen",
reworkTitle: "Zurückschicken",
reworkHint: "Sagen Sie, was nachgebessert werden muss. Die ausführende Person sieht Ihre Notiz und reicht es nach der Korrektur erneut zur Prüfung ein.",
reworkReasonPlaceholder: "z.B. Für X fehlen Fotos, tatsächliche Kosten nicht ausgefüllt, Anmerkungen unklar",
evidenceTitle: "Fotos anfordern",
evidenceHint: "Sagen Sie, was Sie sehen müssen. Der Auftrag bleibt zur Prüfung bei Ihnen, während die Fotos ergänzt werden.",
evidenceReasonPlaceholder: "z. B. Ein deutliches Foto des unteren Befestigungsbereichs",
requestEvidence: "Fotos anfordern",
rework: "Zurückschicken",
},
detailScreen: {
  followUpNeeded: "Folgearbeit nötig: {{reason}}.",
  receiptsAndInvoices: "Belege und Rechnungen",
  verifyInTheirPlace: "Stellvertretend überprüfen",
  completedSolo: "Erledigt. Der Auftrag ist abgeschlossen.",
  assignedInviteFailedBody: "Der Auftrag ist zugewiesen, aber die Einladungs-E-Mail konnte nicht gesendet werden. Sagen Sie bitte selbst Bescheid.",
  assignedInviteFailedTitle: "Zugewiesen, aber die E-Mail wurde nicht gesendet",
  noTeamBody: "Es war nicht erkennbar, zu welchem Team dieser Auftrag gehört; der Auftragnehmer wurde nicht eingeladen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  noTeamTitle: "Kein Team für diesen Auftrag",
  failedToResume: "Der Auftrag wurde nicht fortgesetzt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  failedToAssign: "Der Auftrag wurde nicht zugewiesen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
addTitleFirst: "Fügen Sie zuerst einen Titel hinzu",
addDescriptionFirst: "Fügen Sie zuerst eine Beschreibung hinzu",
typeOrDictateTitleHint: "Geben oder diktieren Sie einen kurzen Titel und verwenden Sie dann „Mit KI verbessern“.",
typeOrDictateDescriptionHint: "Geben Sie eine Beschreibung ein oder diktieren Sie sie und verwenden Sie dann „Mit KI verbessern“.",
unableToImproveText: "Der Text konnte nicht verbessert werden",
tryAgain: "Bitte erneut versuchen.",
verifiedInPlaceOf: "Verifiziert anstelle von {{name}}",
couldNotVerify: "Konnte nicht überprüft werden",
tryAgainShort: "Versuchen Sie es erneut.",
stageAdded: "{{stage}} hinzugefügt",
couldNotAddCheck: "Diese Prüfung konnte nicht hinzugefügt werden",
precheckFirst: "Zuerst Vorprüfung durchführen",
notNow: "Später",
runStage: "Führen Sie {{stage}} aus",
couldNotStartJob: "Dieser Arbeitsauftrag konnte nicht gestartet werden",
movedToStatus: "Verschoben nach {{status}}",
couldNotMoveJob: "Dieser Arbeitsauftrag konnte nicht verschoben werden",
acceptedOn: "Akzeptiert am",
rejectedOn: "Abgelehnt am",
sentToLine: "Gesendet an {{names}}.",
missingEmailForLine: "Fehlende E-Mail für {{names}}.",
noInvoiceOrReceiptAttached: "Es wurden keine Rechnungs- oder Quittungsdateien angehängt.",
completionSentTitle: "Fertigstellung gesendet",
completionEmailSent: "Abschluss-E-Mail gesendet.",
emailNotSentTitle: "E-Mail nicht gesendet",
visitConfirmed: "Besuch bestätigt",
awaitingVisitConfirmation: "Warten auf Besuchsbestätigung",
recipientLine: "{{label}}: {{name}}",
recipientEmailSuffix: " ({{email}})",
requesterDeliveryLine: "Anforderer: {{status}}",
assigneeDeliveryLine: "Zuständige Person: {{status}}",
helpMeWithJobDraft: "Helfen Sie mir bei diesem Arbeitsauftrag: {{title}}. Schlagen Sie die nächsten Schritte oder einen Abschlussentwurf vor.",
currentJobFallback: "Aktueller Arbeitsauftrag",
captureNotSavedTitle: "Aufnahme nicht gespeichert",
captureNotFoundBody: "Diese Aufnahme konnte nicht gefunden werden. Bitte nehmen Sie sie noch einmal auf.",
captureMismatchBody: "Diese Erfassung stimmt nicht mit dem aktuellen Arbeitsauftrag überein.",
noPhotoWasCaptured: "Es wurde kein Foto aufgenommen.",
mustBeSignedInToSavePhotos: "Sie müssen angemeldet sein, um Fotos speichern zu können.",
capturedFromHome: "Von der Startseite aus aufgenommen",
photoAddedToActivity: "Foto zur Arbeitsauftragsaktivität hinzugefügt",
noDictationTextCaptured: "Es wurde kein Diktattext erfasst.",
jobUpdateAdded: "Update veröffentlicht. Alle Beteiligten sehen es unter Aktivität.",
noNoteTextCaptured: "Es wurde kein Notiztext erfasst.",
activityNoteAdded: "Notiz hinzugefügt. Alle Beteiligten sehen sie unter Aktivität.",
readingCostNotePrefix: "Ablesung/Kostennotiz: {{value}}",
readingAddedToActivity: "Zählerstand zur Auftragsaktivität hinzugefügt",
captureNotSupportedTitle: "Aufnahme nicht unterstützt",
qrScanNotSavedBody: "QR-Scan wird vom Scanner durchgeführt und nicht in der Arbeitsauftragsaktivität gespeichert.",
captureModeNotSupported: "Dieser Erfassungsmodus wird für Arbeitsaufträge nicht unterstützt.",
skillsUnavailableTitle: "Fähigkeiten nicht verfügbar",
skillsUnavailableBody: "Fertigkeiten konnten momentan nicht geladen werden. Sie können es in der Auswahl erneut versuchen.",
followOnTitleSuffix: "{{title}} (Folgeauftrag)",
workFallback: "Arbeit",
revisedWorkSubmitted: "Überarbeitete Arbeit zur Prüfung gesendet. Die prüfende Person wurde benachrichtigt.",
completionSubmittedAwaitingVerification: "Zur Prüfung gesendet. Die prüfende Person bestätigt ihn oder schickt ihn zurück.",
unableToCleanUp: "Bereinigung nicht möglich",
changeApproved: "Änderung genehmigt. Der Auftrag zeigt das neue Datum oder die neue Person, und die anfragende Person wurde benachrichtigt.",
requestRejected: "Anfrage abgelehnt. Der Auftrag bleibt unverändert, und die anfragende Person wurde benachrichtigt.",
error: "Etwas ist schiefgelaufen",
couldNotRecordDecision: "Ihre Entscheidung wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
savedOnDeviceWillSend: "Auf diesem Gerät gespeichert – es wird gesendet, wenn Sie wieder online sind",
requestSent: "Anfrage gesendet. Nichts ändert sich, bis die zuständige Person zustimmt; Sie werden benachrichtigt.",
couldNotSendRequest: "Ihre Anfrage wurde nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
outcomeLinePrefix: "Ergebnis: {{value}}",
meterReadingTitle: "Zählerstand",
enterMeterReadingBody: "Geben Sie den Zählerstand als Zahl ein oder lassen Sie das Feld leer.",
readingLowerThanCurrentBody: "{{amount}} ist niedriger als der aktuelle {{current}}. Überprüfen Sie die Nummer – oder tragen Sie eine Korrektur auf der Wartungskarte der Anlage ein.",
readingLowerThanEarlierBody: "Dieser Messwert ist niedriger als ein früherer Wert. Überprüfen Sie die Nummer.",
readingAlreadyRecordedAfterBody: "Nach diesem ist bereits ein Messwert von {{current}} aufgezeichnet. Überprüfen Sie die Nummer.",
laterReadingAlreadyRecordedBody: "Ein späterer Messwert ist bereits erfasst. Überprüfen Sie die Nummer.",
meterReadsInUnitBody: "Dieser Zähler misst in {{unit}}.",
completionSubmittedAwaitingOwnerVerification: "Zur Prüfung gesendet. Wer den Auftrag erstellt hat, prüft ihn und bestätigt ihn oder schickt ihn zurück.",
failedToComplete: "Der Auftrag wurde nicht gesendet. Ihre Notizen und Fotos bleiben erhalten. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
completeRequiredDetailsFirstTitle: "Vervollständigen Sie zuerst die erforderlichen Details",
pleaseFixBeforeSubmitting: "Bitte beheben Sie diese, bevor Sie den Abschluss einreichen:\n{{list}}",
goToCompletion: "Gehen Sie zum Abschluss",
cancel: "Abbrechen",
costBreakdownActionUnavailable: "Kostenaufschlüsselungsaktion nicht verfügbar. Bitte aktualisieren Sie die App.",
jobAccepted: "Auftrag angenommen. Tippen Sie auf Starten, wenn Sie beginnen.",
failedToAccept: "Der Auftrag wurde nicht angenommen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
workApproved: "Arbeit bestätigt. Der Auftrag ist abgeschlossen und die Anlagenhistorie aktualisiert.",
requireSignOffForJobsThisSize: "Abnahme für Aufträge dieser Größe verlangen",
failedToApprove: "Die Arbeit wurde nicht bestätigt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
cannotCreateCertificateTitle: "Zertifikat kann nicht erstellt werden",
cannotCreateCertificateBody: "Dieser Arbeitsauftrag ist nicht mit einer Anlage verknüpft.",
certificateCreatedTitle: "Zertifikat erstellt",
certificateCreatedBody: "Das Zertifikat ist mit diesem Arbeitsauftrag und dieser Anlage verknüpft.",
couldNotCreateCertificate: "Zertifikat konnte nicht erstellt werden.",
deleteJobTitle: "Auftrag löschen",
actionCannotBeUndone: "Diese Aktion kann nicht rückgängig gemacht werden.",
delete: "Löschen",
jobDeleted: "Arbeitsauftrag gelöscht",
failedToDelete: "Der Auftrag wurde nicht gelöscht. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
titleRequiredTitle: "Titel erforderlich",
enterFollowOnTitleBody: "Geben Sie einen Titel für den Folgeauftrag ein.",
skillsRequiredTitle: "Kenntnisse erforderlich",
selectRequiredSkillBody: "Wählen Sie mindestens eine Fähigkeit für diesen Folgeauftrag.",
followUpJobCreated: "Folgeauftrag erstellt. Er steht unter Arbeit und ist mit diesem Auftrag verknüpft.",
followUpCreatedTitle: "Folgeauftrag erstellt",
followUpCreatedBody: "Verknüpfter Folgeauftrag erstellt. Sie können ihn über „Abschluss“ öffnen oder mit dem Abschluss dieses Auftrags fortfahren.",
failedToCreateFollowOn: "Der Folgeauftrag wurde nicht erstellt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedToApproveFollowOn: "Der Folgeauftrag wurde nicht genehmigt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
notApproved: "Nicht genehmigt",
followUpNotApproved: "Folgeauftrag abgelehnt. Er ist storniert, und Ihr Grund steht in seinem Verlauf.",
failedToRejectFollowOn: "Der Folgeauftrag wurde nicht abgelehnt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
linkAContact: "Verknüpfen Sie einen Kontakt",
requesterFallback: "Antragsteller",
draftCloseout: "Notiz mit KI entwerfen",
draftInvoice: "Rechnungsentwurf",
loadingJobDetails: "Arbeitsauftragsdetails werden geladen...",
unableToLoadJob: "Arbeitsauftrag konnte nicht geladen werden",
jobNotFound: "Arbeitsauftrag nicht gefunden",
ownerFallback: "Inhaber",
parentJobApproverFallback: "Genehmiger für übergeordnete Arbeitsaufträge",
assigneeFallback: "Zuständige Person",
everyoneDeclinedYouInviteMore: "Alle Eingeladenen haben abgelehnt – Sie laden weitere ein",
everyoneDeclined: "Alle Eingeladenen lehnten ab",
contractorsSubmitQuotes: "Auftragnehmer geben Angebote ab",
youRequestQuotes: "Sie fordern Angebote an",
ownerRequestsQuotes: "Eigentümer fordert Angebote an",
youPickAContractor: "Sie wählen einen Auftragnehmer aus",
ownerPicksAContractor: "Der Eigentümer wählt einen Auftragnehmer aus",
youAssignTheJob: "Sie weisen den Arbeitsauftrag zu",
ownerAssignsTheJob: "Eigentümer weist den Arbeitsauftrag zu",
requesterConfirmsFixNamed: "{{name}} bestätigt die Behebung",
assignedPrefix: "Zugewiesen",
assignedToSuffix: " an {{name}}",
resolveBeforeSubmitting: "Beheben Sie dieses Problem, bevor Sie den Abschluss senden.",
tightenEvidenceCostsNotes: "Straffen Sie Nachweise, Kosten oder Notizen, damit die Genehmigung unkompliziert ist.",
captureFollowUpWorkHint: "Erfassen Sie Folgearbeiten oder einen verknüpften Auftrag, damit nichts verloren geht.",
noScheduledStartExplanation: "Für diesen Arbeitsauftrag ist kein Start geplant.",
setScheduleRecommendedAction: "Noch kein Datum. Wählen Sie ein Datum oder weisen Sie ihn zu, damit er nicht liegen bleibt.",
pastScheduledStartExplanation: "Dieser Arbeitsauftrag hat sein geplantes Start- oder Fälligkeitsdatum überschritten.",
updateScheduleRecommendedAction: "Das Datum ist überschritten. Planen Sie neu oder informieren Sie den Anfragenden.",
completionChecksClear: "Die Abschlussprüfungen sind für den aktuellen Datensatz in Ordnung.",
keepUpdatesAlignedAction: "Halten Sie Aktualisierungen, Nachweise, Kosten und Notizen während des Arbeitsfortschritts aufeinander abgestimmt.",
reviewCompletion: "Abschluss prüfen",
openCompletion: "Abschluss öffnen",
setSchedule: "Zeitplan festlegen",
updateSchedule: "Zeitplan aktualisieren",
inspectionLine: "Inspektion: {{label}}",
openRelatedAsset: "Zugehörige Anlage öffnen",
jobInsight: "Einblick in Arbeitsaufträge",
insightWarnings_one: "{{count}} Warnung",
insightWarnings_other: "{{count}} Warnungen",
insightBlockers_one: "{{count}} Blocker",
insightBlockers_other: "{{count}} Blocker",
insightSummaryLine: "{{warnings}}, {{blockers}}",
followUp: "Folgearbeiten",
suggested: "Empfohlen",
thisJobsChecksAndStatus: "Prüfungen und Status dieses Arbeitsauftrags",
contractorWorkspace: "Auftragnehmer-Arbeitsbereich",
nextLine: "Als Nächstes: {{value}}",
statusUnavailable: "Status nicht verfügbar",
updatesNew: "Updates · neu",
updates: "Updates",
hideStatusHistory: "Statusverlauf ausblenden",
statusHistory: "Statusverlauf",
hideCompletionAndCosts: "Fertigstellung und Kosten ausblenden",
completionAndCosts: "Fertigstellung & Kosten",
cancelJob: "Auftrag abbrechen",
deleteJobAction: "Auftrag löschen",
moreJobOptions: "Weitere Arbeitsauftragsoptionen",
approveCompletion: "Bestätigen",
cantDoThis: "Ablehnen",
assignDirectly: "Direkt zuweisen",
jobAssistant: "Arbeitsauftragsassistent",
readOnly: "Schreibgeschützt",
jobCreated: "Auftrag erstellt",
suggestedNextStepLine: "Vorgeschlagener nächster Schritt: {{step}}.",
trackProgressHint: "Verfolgen Sie den Fortschritt in der Aktivität und schließen Sie den Vorgang ab, wenn die Arbeit abgeschlossen ist.",
dismissJobCreatedMessage: "Meldung „Arbeitsauftrag erstellt“ verwerfen",
gotIt: "Verstanden",
atAGlance: "Auf einen Blick",
status: "Status",
next: "Als Nächstes",
visit: "Besuch",
cost: "Kosten",
openAssetLabel: "Öffnen Sie die Anlage {{name}}",
relatedRecords: "Zugehörige Datensätze",
couldNotSaveJobDetails: "Arbeitsauftragsdetails konnten nicht gespeichert werden.",
jobOptions: "Arbeitsauftragsoptionen",
linkContactToJob: "Kontakt mit Arbeitsauftrag verknüpfen",
relationship: "Beziehung",
couldNotAddExtractedLineItem: "Die ausgelesene Position konnte nicht hinzugefügt werden",
jobFallback: "Auftrag",
signInRequiredToUpload: "Zum Hochladen ist eine Anmeldung erforderlich.",
reopenJob: "Arbeitsauftrag erneut öffnen",
startJob: "Auftrag starten",
acceptJob: "Arbeitsauftrag annehmen",
workPath: "Wer es übernimmt",
overdue: "Überfällig",
unscheduled: "Nicht geplant",
onSiteLine: "Vor Ort: {{location}}",
fromInspectionLine: "Von der Inspektion – {{label}}",
followOnOfLine: "Folgeauftrag zu — {{title}}",
parentJobFallback: "übergeordneter Arbeitsauftrag",
requestedByLine: "Angefordert von — {{name}}",
roleAndNameLine: "{{role}} — {{name}}",
jobAssigned: "Auftrag zugewiesen. Die Person wurde benachrichtigt und muss ihn annehmen.",
contractorAssigned: "Auftragnehmer zugewiesen. Er hat eine Einladung erhalten und muss den Auftrag annehmen.",
jobResumed: "Auftrag fortgesetzt. Tippen Sie auf Abschließen, wenn die Arbeit erledigt ist.",
},
closeout: {
  extractLineItems: "Positionen aus der Rechnung lesen",
  extractingLineItems: "Rechnung wird gelesen…",
  generatingInvoice: "Rechnung wird erstellt…",
  materialsSummary: "Fügen Sie Teile und Material hinzu. Wir rechnen sie für die Rechnung zusammen.",
followUpTitle: "Folgearbeiten",
suggestFollowUpWork: "Schlagen Sie Folgearbeiten vor",
suggestNextSteps: "Nächste Schritte vorschlagen",
apply: "Übernehmen",
skillLine: "Fähigkeit: {{value}}",
riskLine: "Risiko: {{value}}",
costsAndInvoicesIncluded: ". Kosten und Rechnungen sind unten aufgeführt.",
completedThisLine: "{{name}} hat dies abgeschlossen{{when}}. ",
requesterConfirmsFix: "Die anfragende Person bestätigt die Behebung",
ownerFallback: "Inhaber",
addDetailsBeforeSubmitting: "Fügen Sie vor dem Absenden Abschlussdetails hinzu.",
submitCompletion: "Abschluss einreichen",
completion: "Fertigstellung",
followUpJobsTitle: "Folgeaufträge",
followUpJobsSummary: "Fügen Sie Folgeaufträge hinzu oder prüfen Sie sie, sobald die Abschlussnotiz fertig ist.",
proposeFollowOnJob: "Folgeauftrag vorschlagen",
linkedHeldForApproval: "Mit diesem Arbeitsauftrag verknüpft und zur Genehmigung zurückgehalten.",
proposeMoreWork: "Weitere Arbeit vorschlagen",
proposeMoreWorkHint: "Er geht als Anfrage an sie. Sie entscheiden, und Sie sehen die Antwort hier.",
proposalSent: "Vorschlag gesendet",
proposalWaiting: "Wartet auf Entscheidung",
proposalApproved: "Genehmigt",
proposalBecameJob: "Wurde zum Auftrag",
proposalNotTaken: "Nicht weiterverfolgt",
followUpJobsLinkedTitle: "Folgearbeitsaufträge verknüpft",
createdNowPrefix: "Jetzt erstellt: ",
followUpPrefix: "Folgeauftrag: ",
pendingApprovalSuffix: " · Genehmigung steht aus",
followUpLinkedContinueBody: "Der Folgeauftrag ist verknüpft. Sie können weitermachen und diesen Auftrag abschließen.",
requiredBeforeSubmit: "Vor dem Absenden erforderlich",
beforeYouSubmit: "Bevor Sie absenden",
workCompleted: "Arbeit abgeschlossen",
workCompletedPlaceholder: "Welche Arbeiten wurden abgeschlossen?",
rewriting: "Wird überarbeitet…",
rewrite: "Mit KI überarbeiten",
revert: "Zurücksetzen",
actualCost: "Tatsächliche Kosten",
leaveBlankToRecordAsZero: "Lassen Sie das Feld leer, um es als 0 aufzuzeichnen. Geben Sie den vollständigen Betrag für diesen Arbeitsauftrag ein, wenn eine Gebühr angefallen ist.",
fromCostBreakdownReadOnly: "Aus Kostenaufschlüsselung (schreibgeschützt)",
verifiedLine: "Verifiziert {{date}} | Tatsächliche Kosten {{amount}}",
costsLockedPendingVerification: "Kosten sind gesperrt, während der Abschluss auf die Überprüfung wartet.",
quickFinishHint: "Schnelle Fertigstellung: Fertigstellungsdetails und tatsächliche Kosten hinzufügen und dann absenden.",
costSummary: "Kostenübersicht",
estimateLine: "Schätzung: {{value}}",
actualTotalLine: "Tatsächliche Gesamtsumme: {{value}}",
vsEstimateLine: "vs. Schätzung: {{value}}",
actualCostHint: "Die tatsächlichen Kosten sollten alle Kosten für diesen Arbeitsauftrag umfassen.",
optionalBreakdownHint: "Optional: Fügen Sie nur bei Bedarf eine detaillierte Aufschlüsselung hinzu.",
detailedCostBreakdown: "Detaillierte Kostenaufschlüsselung",
detailedCostBreakdownSummary: "Material-, Arbeits-, Steuer- und andere Kosten sind optional, es sei denn, für diesen Arbeitsauftrag sind detaillierte Kosten erforderlich.",
optionalDetailedCostBreakdown: "Optionale detaillierte Kostenaufschlüsselung",
materialsBreakdownOptional: "Materialaufschlüsselung (optional)",
lineItemsOptional: "Einzelposten (optional)",
failedToAddLineItem: "Die Position wurde nicht hinzugefügt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
add: "Hinzufügen",
itemName: "Artikelname",
removeItemTitle: "Artikel entfernen",
removeItemBody: "Diese Position entfernen?",
cancel: "Abbrechen",
remove: "Entfernen",
error: "Etwas ist schiefgelaufen",
failedToUpdateLineItem: "Die Position wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedToRemoveLineItem: "Die Position wurde nicht entfernt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedToUpdateQty: "Die Menge wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedToUpdateUnitCost: "Der Stückpreis wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedToUpdateTotalCost: "Die Summe wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
quantityForItem: "Menge für {{name}}",
itemFallback: "Artikel",
qty: "Menge",
unitCostForItem: "Stückkosten für {{name}}",
unit: "Einheit",
totalForItem: "Summe für {{name}}",
total: "Gesamt",
fromQtyTimesUnit: "Aus Menge × Einheit: {{amount}}",
manualTotalOverrideSuffix: " (Summe von Ihnen geändert)",
useCalculatedTotal: "Berechnete Summe verwenden",
materialsSubtotal: "Zwischensumme Materialien: {{amount}}",
labourTaxOtherOptional: "Arbeits-, Steuer- und andere Abgaben (optional)",
costBreakdownOptional: "Kostenaufschlüsselung (optional)",
failedToRemoveBreakdown: "Die Aufschlüsselung wurde nicht entfernt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedToAddCostBreakdown: "Die Aufschlüsselung wurde nicht hinzugefügt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
removeBreakdown: "Aufschlüsselung entfernen",
addBreakdown: "Aufschlüsselung hinzufügen",
labourExTax: "Arbeitsaufwand (ohne Steuern)",
taxEntry: "Steuereintrag",
amount: "Betrag",
percentOfLabour: "% der Arbeit",
taxAmount: "Steuerbetrag",
taxRatePercentOfLabour: "Steuersatz (% der Arbeit)",
taxRateLine: "Steuersatz: {{pct}}%",
otherCharges: "Sonstige Gebühren",
otherChargeLabel: "Bezeichnung der sonstigen Gebühr {{n}}",
label: "Bezeichnung",
otherChargeAmount: "Sonstige Gebühr {{n}} Betrag",
totalBreakdownLine: "Gesamt = Materialien {{materials}} + Arbeit {{labour}} + Steuer {{tax}} + Sonstiges {{other}}",
totalLine: "Gesamt: {{amount}}",
invoicesAndCloseoutEmail: "Rechnungen und Bericht-E-Mail",
invoicesAndCloseoutEmailSummary: "Hängen Sie Rechnungen an oder senden Sie den Bericht, sobald die Abschlussnotiz fertig ist.",
invoiceLabel: "Rechnung (PDF, Bild oder Word)",
generateInvoiceWithAi: "Rechnung mit KI erstellen",
reviewInvoiceDraft: "Überprüfen Sie den Rechnungsentwurf",
signInRequired: "Anmeldung erforderlich",
emailCloseoutRecipients: "Bericht an den Anfragenden senden",
emailAlwaysIncludesSummary: "Die E-Mail enthält eine Zusammenfassung der Arbeit. Rechnungen, Belege und Fotos werden angehängt, wenn vorhanden.",
},
assetContextSection: {
asset: "Anlage",
viewAssetKnowledgeBase: "Anlagenwissensdatenbank anzeigen",
viewAssetKnowledge: "Anlagenwissen anzeigen",
noAssetLinked: "Mit diesem Arbeitsauftrag ist keine Anlage verknüpft.",
overview: "Übersicht",
location: "Standort",
fromLinkedAsset: "Von verknüpfter Anlage",
aboutThisJob: "Über diesen Arbeitsauftrag",
approverLine: "Genehmiger: {{name}}",
approverFallback: "-",
sectionOfInterest: "Abschnitt von Interesse",
viewSourceInspection: "Quelleninspektion anzeigen",
fromInspection: "Von der Inspektion",
video: "Video",
photos: "Fotos",
linkedRecords: "Verknüpfte Datensätze",
fromRequestLine: "Von Anfrage: {{id}}",
followsFromLine: "Folgt aus: {{title}}",
parentJobFallback: "Übergeordneter Arbeitsauftrag",
followOnLine: "Folgeauftrag: {{title}}",
sourceLine: "Quelle: {{label}}",
groupedScheduleLine_one: "{{count}} weiterer aktiver Arbeitsauftrag für diese Anlage kann gemeinsam geplant werden.",
groupedScheduleLine_other: "{{count}} weitere aktive Arbeitsaufträge für diese Anlage können gemeinsam geplant werden.",
},
scheduleSection: {
rescheduleTo: "Neu planen auf",
scheduleFor: "Einplanen für",
today: "Heute",
tomorrow: "Morgen",
nextWeek: "Nächste Woche",
custom: "Benutzerdefiniert",
selectDate: "Datum wählen",
time: "Uhrzeit",
selectTime: "Uhrzeit auswählen",
duration: "Dauer",
plannedLine: "Geplant: {{value}}",
reasonOptional: "Grund (optional)",
reasonForReschedulePlaceholder: "Grund für die Neuplanung",
scheduleTogetherOptional: "Gemeinsam einplanen (optional)",
groupSameAssetHint: "Fassen Sie Arbeiten an derselben Anlage zusammen, um wiederholte Besuche zu vermeiden.",
unscheduledSuffix: " | Nicht geplant",
cancel: "Abbrechen",
reschedule: "Neu planen",
schedule: "Planen",
},
deliveryModeSheet: {
cancel: "Abbrechen",
saving: "Wird gespeichert...",
save: "Speichern",
},
mediaViewer: {
couldNotLoadImage: "Bild konnte nicht geladen werden",
imageUnavailable: "Das Bild wurde möglicherweise verschoben oder ist nicht verfügbar.",
},
handoffRecommendationPanel: {
  evidence: {
    beforeAfter: "Zum Abschluss: Vorher-nachher-Fotos und eine kurze Notiz.",
    replacementPhotos: "Zum Abschluss: Vorher-nachher-Fotos und was eingebaut wurde.",
    checklistPhotos: "Zum Abschluss: die ausgefüllte Checkliste und Fotos von allem, was nicht bestanden hat.",
  },
  reason: {
    originKept: {
      finding: "Er bleibt mit dem Inspektionsbefund verknüpft.",
      inspection: "Er bleibt mit der Inspektion verknüpft.",
      request: "Er bleibt mit der Anfrage verknüpft.",
      asset: "Er bleibt mit der Anlage verknüpft.",
    },
    noOrigin: "Prüfen Sie die Angaben oben, bevor Sie ihn erstellen.",
    skillsUnconfirmed: "Noch keine Fähigkeiten. Fügen Sie sie hinzu, wenn ein bestimmtes Gewerk nötig ist.",
    skillsCarried_other: "{{count}} Fähigkeiten sind bereits beim Auftrag hinterlegt.",
    skillsCarried_one: "{{count}} Fähigkeit ist bereits beim Auftrag hinterlegt.",
    dueByPriority_other: "Priorität {{priority}}: Ziel ist der Abschluss innerhalb von {{count}} Tagen.",
    dueByPriority_one: "Priorität {{priority}}: Ziel ist der Abschluss innerhalb von {{count}} Tag.",
    contractorNoInternal: "Niemand aus Ihrem Team ist frei: Wählen Sie einen Auftragnehmer.",
    contractorFromSourceJob: "Er geht an den Auftragnehmer zurück, der den Auftrag erledigt hat, aus dem er stammt.",
    contractorCritical: "Niemand aus Ihrem Team ist frei und es ist dringend: Senden Sie ihn direkt an einen Auftragnehmer Ihres Vertrauens.",
    quotesHighValue: "Niemand aus Ihrem Team ist frei und die Arbeit ist teuer: Vergleichen Sie zuerst einige Angebote.",
    internalAvailableUnnamed: "Jemand aus Ihrem Team kann es übernehmen.",
    internalAvailable: "{{name}} aus Ihrem Team kann es übernehmen.",
  },
recommendedHandoff: "Vorschlag",
titleLine: "{{mode}} · fällig in {{days}} {{dayWord}}",
dayWord_one: "Tag",
dayWord_other: "Tagen",
applied: "Übernommen",
apply: "Diesen Vorschlag verwenden",
whyRecommendedTitle: "Warum?",
priorityOverrideLine: "Priorität: {{priority}}. Ändern Sie sie unter Kontext hinzufügen, falls sie nicht stimmt.",
planningRangeLine: "Planungsbereich {{min}}–{{max}}; vor der Beauftragung bestätigen.",
},
statusInsight: {
theReviewer: "Die prüfende Person",
reworkRequested: "Zurückgeschickt",
workPath: "Wer es übernimmt",
updating: "Wird aktualisiert...",
internal: "Intern",
recipientView: "Empfängeransicht",
recipientViewBody: "Sie können diesen Arbeitsauftrag überprüfen. Die Bearbeitung ist auf das beschränkt, was Ihre Rolle zulässt.",
execution: "Ausführung",
executionBody: "Wenn die Arbeit erledigt ist, tippen Sie auf Abschließen, um Notiz, Fotos und Kosten hinzuzufügen.",
nextStep: "Nächster Schritt",
nextLine: "Als Nächstes: {{actor}}",
followOnApproval: "Genehmigung des Folgeauftrags",
followOnApprovalBody: "Genehmigen Sie diesen Folgeauftrag, damit er zugewiesen und terminiert werden kann.",
awaitingFollowOnApproval: "Wartet auf Genehmigung",
waitingForApproverBody: "Dieser Folgeauftrag wartet auf Genehmigung. Bis dahin kann er weder zugewiesen noch terminiert werden.",
waitingForParentApproverBody: "Dieser Arbeitsauftrag kann erst zugewiesen oder geplant werden, wenn der übergeordnete Arbeitsauftragsgenehmiger eine Entscheidung trifft.",
overdue: "Überfällig",
unscheduled: "Nicht geplant",
},
activitySection: {
  assistantChange: "Über den Assistenten geändert",
  assistantUndone: "Änderung des Assistenten rückgängig gemacht",
  playVideo: "Video abspielen",
  openPhoto: "Foto öffnen",
statusNone: "Keine",
systemActor: "Automatisch",
userFallback: "Jemand aus dem Team",
taskTimeline: "Aufgabenzeitleiste",
purposeHint: "Status, Nachrichten, Nachweise und Aktionen in einem chronologischen Arbeitsbereich.",
noStatusEvents: "Noch keine Statusereignisse.",
recentEvidence: "Aktuelle Nachweise",
noMessagesOrEvidence: "Noch keine Nachrichten oder Nachweise.",
openFullTimeline: "Vollständige Timeline öffnen >",
},
assignmentSection: {
contacts: "Kontakte",
noContactsLinked: "Keine Kontakte verknüpft.",
contactFallback: "Kontakt",
couldNotUnlinkTitle: "Die Verknüpfung des Kontakts konnte nicht aufgehoben werden",
tryAgain: "Bitte erneut versuchen.",
linkContact: "Kontakt verknüpfen",
assignmentAndSchedule: "Zuweisung und Zeitplan",
declinedSuffix: "{{name}} (abgelehnt)",
awaitingAssignee: "Warten auf den Beauftragten",
requesterLine: "Anforderer: {{name}}",
requesterEmailSuffix: " ({{email}})",
notLinkedYet: "Noch nicht verlinkt",
scheduledLine: "Geplant: {{value}}",
notScheduledYet: "Noch nicht geplant",
closeoutRecipientsFallback: "Sobald jemand zugewiesen ist, zeigen wir, wer den fertigen Bericht erhält.",
completionEmailLine: "Abschluss-E-Mail: {{value}}",
rejected: "Abgelehnt",
changeAssignee: "Zuständige Person ändern",
change: "Ändern",
reassign: "Neu zuweisen",
contractorType: "Auftragnehmer",
internalTeamType: "Internes Team",
reason: "Grund",
invitedAcceptedDeclinedLine: "Eingeladen: {{total}} | Akzeptiert: {{accepted}} | Abgelehnt: {{declined}}",
pendingSuffix: " | Ausstehend: {{pending}}",
quoteRequestLine: "Angebotsanfrage: {{status}}",
quoteInvitedSubmittedDeclinedLine: "{{invited}} eingeladen | {{submitted}} eingereicht | {{declined}} abgelehnt",
quoteCountLine_one: "{{count}} Angebot: {{open}} offen | {{accepted}} akzeptiert | {{rejected}} abgelehnt",
quoteCountLine_other: "{{count}} Angebote: {{open}} offen | {{accepted}} akzeptiert | {{rejected}} abgelehnt",
awardedToLine: "Vergeben an: {{name}}",
execution: "Die Arbeit",
started: "Gestartet",
completed: "Abgeschlossen",
actualDuration: "Tatsächliche Dauer",
elapsed: "Verstrichen",
confirmed: "Bestätigt",
confirmedBySuffix: " · {{name}}",
verified: "Verifiziert",
continueJob: "Setzen Sie den Arbeitsauftrag fort",
continueJobHint: "Fügen Sie vor dem Absenden Fertigstellungsdetails und tatsächliche Kosten hinzu.",
completion: "Fertigstellung",
},
statusGuidance: {
title: "Status und Anleitung",
},
invoicePreview: {
title: "Überprüfen Sie den KI-Rechnungsentwurf",
hint: "Bestätigen Sie die Details und hängen Sie dann das generierte PDF an diesen Arbeitsauftrag an.",
titleAndNumber: "{{title}} - {{number}}",
issueDate: "Ausgabedatum: {{date}}",
dueDateSuffix: " | Fällig: {{date}}",
from: "Von",
billTo: "Rechnung an",
lineItems: "Einzelposten",
lineItemLine: "{{description}} x{{quantity}} - {{amount}}",
total: "Gesamt: {{amount}}",
noDraftFound: "Kein Entwurf gefunden. Erstellen Sie zunächst einen Rechnungsentwurf.",
back: "Zurück",
attaching: "Wird angehängt…",
attachPdf: "PDF anhängen",
},
followOnModals: {
proposeTitle: "Folgeauftrag vorschlagen",
proposeHint: "Er wartet auf Genehmigung. Danach kann er zugewiesen und terminiert werden.",
titleLabel: "Titel",
descriptionLabel: "Beschreibung",
dictate: "Diktieren",
improving: "Verbesserung…",
improveWithAi: "Verbessern Sie mit KI",
followOnTitleAria: "Titel des Folgeauftrags",
titlePlaceholder: "Titel",
followOnDescriptionAria: "Beschreibung des Folgeauftrags",
descriptionPlaceholder: "Welche zusätzliche Arbeit ist erforderlich?",
insertingDictatedText: "Diktierter Text wird eingefügt...",
finishingDictation: "Diktat wird beendet...",
heardTranscript: "Gehört: {{transcript}}",
listening: "Hört zu...",
photosAndVideos: "Fotos und Videos",
requiredSkills: "Erforderliche Fähigkeiten",
cancel: "Abbrechen",
submitting: "Wird gesendet…",
submitForApproval: "Zur Genehmigung einreichen",
rejectTitle: "Folgeauftrag ablehnen",
rejectHint: "Der Folgeauftrag wird storniert. Geben Sie dem Team einen kurzen Grund an.",
rejectionReasonAria: "Grund für die Ablehnung",
reasonPlaceholder: "Grund",
rejectFollowOn: "Ablehnen",
},
dockBar: {
  waitingForRequester: "Wartet auf den Anfragenden",
approve: "Genehmigen",
reject: "Ablehnen",
accept: "Annehmen",
acceptAndStart: "Annehmen und starten",
acceptAndSchedule: "Annehmen und planen",
cantDoThis: "Ablehnen",
reassign: "Neu zuweisen",
rework: "Zurückschicken",
requestEvidence: "Fotos anfordern",
verify: "Abzeichnen",
resubmit: "Erneut einreichen",
getQuotes: "Angebote einholen",
inviteMore: "Mehr einladen",
compare: "Vergleichen",
sendQuotes: "Angebote senden",
assign: "Zuweisen",
startNow: "Jetzt starten",
schedule: "Planen",
start: "Starten",
reschedule: "Neu planen",
complete: "Abschließen",
pause: "Pausieren",
resume: "Fortsetzen",
report: "Bericht",
},
certificateSuggestion: {
needsConnection: "Zertifikatsvorschläge benötigen eine Verbindung.",
evidenceDoesNotSupport: "Der Abschlussnachweis unterstützt noch nicht eindeutig ein Zertifikat.",
createPendingTitle: "Ausstehendes Zertifikat erstellen",
createPendingBody: "Aus diesem Arbeitsauftrag ein Zertifikat erstellen? Es bleibt bis zur Prüfung als ausstehend markiert.",
cancel: "Abbrechen",
continue: "Weiter",
jobFallback: "Auftrag",
certificateSuffix: "{{title}}-Zertifikat",
titleLine: "Titel: {{value}}",
typeLine: "Typ: {{value}}",
expiryLine: "Ablauf: {{value}}",
cardTitle: "Schlagen Sie ein Zertifikat aus dem Abschlussnachweis vor",
optionalAiHint: "Optionale KI-Unterstützung nach Abschluss des Arbeitsauftrags.",
reviewDraftLabel: "Überprüfen Sie den Zertifikatsentwurf",
suggestWithAi: "Zertifikat mit KI vorschlagen",
addManually: "Zertifikat manuell hinzufügen",
},
verified: {
  submitCheckNote: "Beim Absenden prüft die KI die Nachher-Fotos gegen die Anforderungen des Auftrags.",
  documentHintSheet: "Schließen Sie dies und tippen Sie im Auftrag auf Dokument anhängen.",
  noteHintSheet: "Schreiben Sie sie in die Abschlussnotiz auf diesem Bildschirm.",
  noteHint: "Schreiben Sie sie in die Abschlussnotiz, wenn Sie auf Abschließen tippen.",
  attachDocument: "Dokument anhängen",
  recordReading: "Zählerstand erfassen",
  heading: "Was dieser Auftrag braucht",
  progress: "{{done}} von {{total}} erledigt",
  takePhoto: "Foto aufnehmen",
  stage: {
    pre: "Vor dem Start",
    post: "Zum Abschluss",
    standalone: "Checkliste",
  },
  beforePhoto: "Vorher-Foto",
  afterPhoto: "Nachher-Foto",
  beforePhotos: "Vorher-Fotos",
  addBeforePhoto: "Vorher-Foto hinzufügen",
  required: "Erforderlich",
  recommended: "Empfohlen",
  rowState: {
    notSupplied: "Nicht bereitgestellt",
    done: "Erledigt",
    uploading: "Wird hochgeladen…",
    added: "Hinzugefügt",
    missing: "Fehlt",
    attention: "Bitte prüfen",
    unchecked: "Noch nicht geprüft",
  },
  status: {
    consistent: "Fotos passen zur beschriebenen Arbeit",
    review_required: "Fotos bitte prüfen",
    missing_evidence: "Fotos fehlen",
    inconsistent: "Fotos passen nicht zur beschriebenen Arbeit",
    unable_to_determine: "Aus den Fotos nicht erkennbar",
  },
  checkNote: {
    meter_not_recorded: "Zählerstand nicht erfasst",
    document_not_attached: "Dokument nicht angehängt",
    check_not_completed: "Prüfung nicht abgeschlossen",
    note_missing: "Notiz fehlt",
    not_visible: "Auf den Fotos nicht sichtbar",
    partly_visible: "Nur teilweise sichtbar",
    low_confidence: "Nicht deutlich genug",
    contradicted: "Die Fotos zeigen das Gegenteil",
    cloud_unavailable: "Automatische Bewertung nicht verfügbar",
    not_visually_verifiable: "Aus Fotos nicht feststellbar",
  },
  warning: {
    cloud_unavailable: "Automatische Bewertung nicht verfügbar. Die prüfende Person kann die Nachweise weiterhin ansehen.",
    subject_mismatch: "Vorher- und Nachher-Fotos zeigen möglicherweise nicht dasselbe Bauteil.",
    low_quality_after: "Die Nachher-Fotos sind unscharf, dunkel oder verdeckt. Deutlichere Fotos werden empfohlen.",
    new_defect_after: "Auf den Nachher-Fotos ist ein Mangel sichtbar, den die Arbeit nicht abdeckte.",
    detector_disagreement: "Die Fotos sprechen für beides. Eine Person entscheidet.",
    pending_uploads: "Einige Fotos werden noch hochgeladen und wurden nicht bewertet.",
    reviewer_required: "Diese Arbeit muss von einer prüfenden Person freigegeben werden.",
    post_inspection_required: "Abschließende Inspektion ausstehend.",
  },
  moreEvidenceRequested: "Weitere Fotos angefordert",
  stale: "Nachweise geändert. Die Bewertung muss aktualisiert werden.",
  checkEvidence: "Fotos prüfen",
  checkAgain: "Erneut prüfen",
  checking: "Abschlussnachweise werden geprüft…",
  checkEvidenceA11y: "Abschlussnachweise prüfen",
  resubmit: "Erneut einreichen",
  resubmitA11y: "Abschluss mit den ergänzten Nachweisen erneut einreichen",
  resubmitted: "Erneut zur Prüfung gesendet. Die prüfende Person wurde benachrichtigt.",
  requestEvidence: "Fotos anfordern",
  requestEvidenceA11y: "Weitere Fotos anfordern",
  cloudUnavailable: "Die automatische Fotoprüfung ist gerade nicht verfügbar. Sehen Sie sich die Fotos an und entscheiden Sie.",
  reportEyebrow: "Nachweisbewertung (automatisch)",
  editRequirements: "Anforderungen bearbeiten",
  editSummary: "Checklisten, Fotos und Ergebnisse für diesen Auftrag",
  saved: "Anforderungen gespeichert. Eine frühere Bewertung muss jetzt aktualisiert werden.",
  suggestFailed: "Keine Vorschläge erhalten. Ergebnisse von Hand hinzufügen.",
  kind: {
    visual: "Auf Fotos sichtbar",
    meter: "Zählerstand",
    document: "Dokument",
    check: "Checkliste",
    note: "Notiz",
  },
  remove: "Entfernen",
  removeA11y: "„{{text}}“ entfernen",
  addOutcomePlaceholder: "Erwartetes Ergebnis hinzufügen, z. B. Ersatzschutz vorhanden",
  addOutcome: "Ergebnis hinzufügen",
  suggestWithAi: "Mit KI vorschlagen",
  saveRequirements: "Anforderungen speichern",
  reportPhotosAssessed: "Fotos bewertet",
  reportRecordsOnly: "Nur Datensätze",
},
closeoutPane: {
askForPhotos: "Fotos anfordern",
viewCompletionReport: "Abschlussbericht anzeigen",
emailCloseoutRecipients: "Bericht an den Anfragenden senden",
sending: "Wird gesendet…",
waitingOnRequester: "Warten auf den Anforderer",
verifyCompletedWork: "Abgeschlossene Arbeit abzeichnen",
requesterGatePendingBody: "Der Anfragende prüft die Arbeit zuerst. Sobald er bestätigt, dass er zufrieden ist, tippen Sie auf Bestätigen, um den Auftrag abzuschließen. Zurückschicken ist weiterhin möglich.",
requesterAcceptedBody: "Der Anfragende hat bestätigt, dass er zufrieden ist. Tippen Sie auf Abzeichnen, um den Auftrag abzuschließen.",
reviewAndApproveBody: "Prüfen Sie Notiz, Fotos und Kosten und tippen Sie dann auf Abzeichnen, um den Auftrag abzuschließen, oder auf Zurückschicken, wenn etwas nachgebessert werden muss.",
requestRework: "Zurückschicken",
rework: "Zurückschicken",
verify: "Abzeichnen",
certificateRenewalTitle: "Zertifikatsverlängerung",
certificateRenewalBody: "Erstellen Sie aus diesem abgeschlossenen Arbeitsauftrag das Ersatzzertifikat und verknüpfen Sie es mit dem vorherigen Zertifikat.",
createCertificateFromJob: "Zertifikat aus Arbeitsauftrag erstellen",
createCertificate: "Zertifikat erstellen",
},
assignSheet: {
  chooseContractorsToQuote: "Auftragnehmer für Angebote wählen",
  chooseContractor: "Auftragnehmer wählen",
  assignToContractor: "Einem Auftragnehmer zuweisen",
  inviteTeammate: "Teammitglied einladen",
close: "Schließen",
youSuffix: "{{name}} (Sie)",
searchTeamMembersPlaceholder: "Teammitglieder suchen…",
noTeamMemberMatch: "Kein passendes Teammitglied gefunden.",
createTeamHint: "Fügen Sie ein Teammitglied hinzu, um ihm Arbeit zuzuweisen, oder weisen Sie sie sich selbst zu.",
teammate: "Einem Teammitglied zuweisen",
assignToMyself: "Mir selbst zuweisen",
},
},
create: {
  skillsTryAgain: "Erneut versuchen",
  skillsEmpty: "Gerade gibt es keine Fähigkeiten zur Auswahl. Tippen Sie auf Erneut versuchen oder fahren Sie ohne fort.",
  createAndAssignJob: "Auftrag erstellen und zuweisen",
  fromRequestPageTitle: "Auftrag aus Anfrage bestätigen",
  checkAttachFailedTitle: "Auftrag erstellt, Checkliste fehlt",
  assetLoadFailed: "Die verknüpfte Anlage konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  assetUnavailable: "Diese Anlage ist nicht verfügbar oder Sie haben keinen Zugriff mehr.",
  assetStatus: {
    retired: "Ausgemustert",
    archived: "Archiviert",
    active: "Aktiv",
  },
  visibilityHint: "Privat: nur Sie und die Personen an diesem Auftrag. Team: Ihr ganzes Team.",
  priorityOption: {
    critical: "Kritisch",
    high: "Hoch",
    medium: "Mittel",
    low: "Niedrig",
  },
  categoryOption: {
    other: "Sonstiges",
    replacement: "Austausch",
    inspection: "Inspektion",
    maintenance: "Wartung",
    repair: "Reparatur",
  },
unsavedGuard: {
message: "Dieser Auftrag wurde noch nicht erstellt. Verlassen und ihn verlieren?",
discard: "Verlassen",
keep: "Bearbeiten Sie weiter",
},
assetRetiredTitle: "Anlage ausgemustert",
assetArchivedTitle: "Anlage archiviert",
assetRetiredBody: "Diese Anlage wurde ausgemustert (außer Betrieb). Ihr Verlauf bleibt lesbar, aber sie nimmt keine neuen Aufträge an.",
assetArchivedBody: "Diese Anlage ist archiviert. Sie können die Anlage weiterhin anzeigen/bearbeiten, aber keine neuen Arbeitsaufträge dafür erstellen.",
linkFollowUpFallback: "Die Anfrage wurde nicht aktualisiert.",
checkAttachFailed: "Der Auftrag wurde erstellt, aber die Checkliste „{{name}}“ wurde nicht hinzugefügt. Öffnen Sie den Auftrag und tippen Sie auf Prüfung hinzufügen.",
createFailed: "Der Auftrag wurde nicht erstellt. Ihre Angaben bleiben erhalten. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
error: "Etwas ist schiefgelaufen",
followUpLinked: "Mit Arbeitsauftrag verknüpfte Nachverfolgung",
calendarInviteTitle: "Arbeitsauftrag: {{name}}",
genericAssetFallback: "Anlage",
recovery: {
followUpTitle: "Auftrag erstellt, Anfrage nicht aktualisiert",
followUpBody: "{{message}} Der Auftrag wurde erstellt. Tippen Sie auf Verknüpfung wiederholen, damit die Anfrage ihn zeigt.",
retryLink: "Verknüpfung wiederholen",
openJob: "Auftrag öffnen",
assetErrorTitle: "Die verknüpfte Anlage konnte nicht geladen werden",
assetLoadingTitle: "Die verknüpfte Anlage wird geladen…",
assetErrorBody: "{{error}} Ihre eingegebene Arbeitsbeschreibung bleibt erhalten.",
retryAsset: "Anlage erneut laden",
requestErrorTitle: "Die Anfrage konnte nicht geladen werden",
requestErrorBody: "Dieser Arbeitsauftrag sollte aus der Anfrage vorab ausgefüllt werden. Versuchen Sie erneut, die Details zu laden. Alle bereits eingegebenen Daten bleiben erhalten.",
retry: "Wiederholen",
},
createdFromRequest: "Aus Anfrage erstellt",
createdFromAsset: "Erstellt aus Anlage",
notSet: "Nicht gesetzt",
noPriority: "Keine Priorität",
openAsset: "Anlage öffnen",
followOnDetailsTitle: "Angaben zum Folgeauftrag",
workBriefTitle: "Arbeitsbeschreibung",
followOnHint: "Mit dem ursprünglichen Auftrag verknüpft{{parent}}. Gleiche Anlage, gleiche Ausführung. Weisen Sie ihn zu und wählen Sie ein Datum, sobald er genehmigt ist.",
workPathTitle: "Wer übernimmt es?",
linkAssetLabel: "Mit Anlage verknüpfen (optional)",
selectAssetPlaceholder: "Anlage wählen",
titleLabel: "Titel",
titlePlaceholder: "z.B. Undichten Wasserhahn reparieren",
titleError: "Geben Sie einen Arbeitsauftragstitel ein, um fortzufahren.",
descriptionLabel: "Beschreiben Sie das Problem (optional)",
descriptionPlaceholder: "Was ist zu tun? Fügen Sie Details hinzu, damit der Beauftragte Kontext hat.",
dictateStop: "Stopp",
dictateStart: "Diktieren",
cleaningUp: "Wird überarbeitet…",
aiCleanUp: "Mit KI überarbeiten",
photosLabel: "Fotos (optional, max. 3)",
completionEvidence: {
  title: "Abschlussnachweise",
  summary: "Welche Nachweise der erledigten Arbeit dieser Auftrag braucht",
  beforePhoto: "Vorher-Foto",
  afterPhoto: "Nachher-Foto",
  level: {
    none: "Nicht nötig",
    recommended: "Empfohlen",
    required: "Erforderlich",
  },
  reviewerRequired: "Freigabe durch prüfende Person",
  postInspection: "Inspektion nach der Arbeit",
  requiredHint: "Erforderliche Nachweise blockieren den Abschluss, bis sie vorliegen.",
  recommendedHint: "Empfohlene Nachweise warnen nur, blockieren aber nie.",
},
categoryLabel: "Kategorie *",
categoryError: "Wählen Sie eine Kategorie, um fortzufahren.",
skillsOptionalLabel: "Fähigkeiten (optional)",
requiredSkillsLabel: "Erforderliche Fähigkeiten",
requiredSkillsError: "Wählen Sie mindestens eine Fähigkeit für den Folgeauftrag. Die des ursprünglichen Auftrags werden übernommen, falls vorhanden.",
requiredSkillsHint: "Wählen Sie mindestens eine Fähigkeit. Die des ursprünglichen Auftrags werden übernommen, falls vorhanden.",
addContext: "Kontext hinzufügen (optional)",
priorityLabel: "Priorität",
locationLabel: "Standort (optional)",
locationPlaceholder: "Adresse suchen…",
assignScheduleTitle: "Zuweisen und planen",
assignScheduleSummary: "Fälligkeitsdatum, Zeitplan und Beauftragter",
dueDateLabel: "Fälligkeitsdatum (optional)",
selectDatePlaceholder: "Datum wählen",
dueDateHint: "Geplantes Fertigstellungsdatum. Lassen Sie das Feld „Planung“ leer, wenn für diese Arbeit noch kein bestimmtes Zeitfenster erforderlich ist.",
scheduledDateLabel: "Geplantes Datum (optional)",
planDatePlaceholder: "Plandatum",
startTimeLabel: "Startzeit",
selectTimePlaceholder: "Uhrzeit auswählen",
estimatedDurationLabel: "Geschätzte Dauer",
suggestedDuration: "Empfohlen: {{duration}} ({{reason}})",
useSuggestedDuration: "Verwenden Sie die empfohlene Dauer",
applied: "Übernommen",
useSuggestion: "Vorschlag übernehmen",
plannedPreview: "Geplant: {{preview}}",
clearSchedule: "Zeitplan entfernen",
inviteLabel: "Einladung (optional)",
setDateHint: "Legen Sie einen Termin fest, um zu planen, wann die Arbeiten beginnen sollen.",
quotesContractorHint: "Sie wählen aus, welche Auftragnehmer Sie zur Angebotserstellung einladen möchten, nachdem der Arbeitsauftrag erstellt wurde.",
directContractorHint: "Sie wählen den Auftragnehmer aus, nachdem der Arbeitsauftrag erstellt wurde.",
assignTeamMemberLabel: "Einem Teammitglied zuweisen (optional)",
searchTeamMembersPlaceholder: "Teammitglieder suchen…",
noTeamMemberMatch: "Kein passendes Teammitglied gefunden.",
assignSuggestedMember: "Weisen Sie das vorgeschlagene Mitglied {{name}} zu",
suggestedAssignee: "Empfohlen: {{name}}",
assignAnytimeHint: "Jetzt zuweisen oder zuweisen, nachdem der Arbeitsauftrag erstellt wurde.",
advancedSettingsTitle: "Weitere Angaben",
advancedSettingsSummary: "Kategorie, Dauer, Prüfungen, Kalendereinladung, Kosten und Sichtbarkeit",
estimatedCostLabel: "Geschätzte Kosten (optional)",
estimatedCostAmount: "Geschätzter Kostenbetrag",
visibilityLabel: "Sichtbarkeit",
submitting: "Wird gesendet…",
submitForApproval: "Zur Genehmigung einreichen",
creating: "Wird erstellt…",
createJob: "Auftrag erstellen",
followOnPageTitle: "Folgeauftrag vorschlagen",
createPageTitle: "Auftrag erstellen",
followOnSubtitle: "Er wartet auf Genehmigung, bevor er zugewiesen werden kann.",
requestSubtitle: "Prüfen Sie die Angaben, wählen Sie, wer es übernimmt und bis wann, und tippen Sie dann auf Auftrag erstellen und zuweisen.",
manualSubtitle: "Beschreiben Sie die Arbeit und wählen Sie eine Kategorie. Anschließend können Sie sie zuweisen und planen.",
linkAssetSheetTitle: "Mit Anlage verknüpfen",
noneOption: "Keine",
openLinkedAsset: "Verknüpfte Anlage öffnen",
cleanedDescriptionTitle: "Bereinigte Beschreibung",
cleaningUpDescription: "Beschreibung wird bereinigt",
reviewSuggestedWording: "Überprüfen Sie den vorgeschlagenen Wortlaut, bevor Sie ihn anwenden.",
unableToCleanUpTitle: "Die Beschreibung konnte nicht bereinigt werden",
tryAgain: "Bitte erneut versuchen.",
},
recurring: {
  addStepNote: "Dieser Plan wird Schritt {{n}} von {{name}}.",
  saved: {
    dateInspection: "Plan gespeichert. Die erste Inspektion erscheint am {{when}} unter Arbeit.",
    dateJob: "Plan gespeichert. Der erste Auftrag erscheint am {{when}} unter Arbeit.",
    meterInspection: "Plan gespeichert. Die erste Inspektion erscheint unter Arbeit, wenn der Zähler {{amount}} erreicht.",
    meterJob: "Plan gespeichert. Der erste Auftrag erscheint unter Arbeit, wenn der Zähler {{amount}} erreicht.",
    eitherInspection: "Plan gespeichert. Die erste Inspektion erscheint unter Arbeit bei {{amount}} oder am {{when}} – je nachdem, was zuerst eintritt.",
    eitherJob: "Plan gespeichert. Der erste Auftrag erscheint unter Arbeit bei {{amount}} oder am {{when}} – je nachdem, was zuerst eintritt.",
    conditionInspection: "Plan gespeichert. Eine Inspektion erscheint unter Arbeit, wenn der Zustandswert auf {{score}} oder darunter fällt.",
    conditionJob: "Plan gespeichert. Ein Auftrag erscheint unter Arbeit, wenn der Zustandswert auf {{score}} oder darunter fällt.",
    manual: "Plan gespeichert. Unter Arbeit erscheint nichts, bis jemand auf dem Tab „Wartung“ der Anlage auf „Jetzt starten“ tippt.",
    needsReading: "Plan gespeichert. Erfassen Sie einen Zählerstand an der Anlage, damit der Plan zu zählen beginnt.",
    nowInspection: "Plan gespeichert. Die erste Inspektion ist jetzt unter Arbeit.",
    nowJob: "Plan gespeichert. Der erste Auftrag ist jetzt unter Arbeit.",
    generic: "Plan gespeichert. Sie finden ihn auf dem Tab „Wartung“ der Anlage.",
  },
  skipPolicy: {
    hint: {
      not_allowed: "Ein Termin kann verschoben oder weitergegeben, aber nie ausgelassen werden.",
      no_approval: "Wer die Arbeit erledigt, kann einen Termin sofort auslassen. Die Genehmiger der Anlage werden informiert.",
      team_admin: "Nur ein Team-Eigentümer oder -Admin kann dem Auslassen eines Termins zustimmen.",
      requires_approval: "Jeder kann bitten, einen Termin auszulassen oder zu verschieben; ein Genehmiger der Anlage entscheidet.",
      default: "Nicht gewählt: Eine Führungskraft entscheidet – ein Team-Admin, wenn für die Anlage eine Compliance-Pflicht gilt.",
    },
    not_allowed: "Nie auslassen",
    no_approval: "Ohne Rückfrage auslassen",
    team_admin: "Ein Team-Admin entscheidet",
    requires_approval: "Eine Führungskraft entscheidet",
    label: "Wenn ein Termin nicht machbar ist",
  },
  meterNowHint: "Wird als erster Zählerstand gespeichert, damit der Plan weiß, ab welchem Stand er zählt.",
  meterNow: "Aktueller Zählerstand",
  createTemplate: "Checkliste erstellen",
  noTemplates: "Noch keine Checklisten. Erstellen Sie eine, sie wird hier für Sie ausgewählt.",
  addDocument: "Dokument hinzufügen",
  pickAssetFirst: "Wählen Sie zuerst die Anlage und dann eines ihrer Dokumente.",
  cannotManage: "Sie können {{asset}} keine Pläne hinzufügen. Fragen Sie den Eigentümer oder einen Team-Admin.",
  assetPickerSubtitle: "Ein Plan gehört zu genau einer Anlage. Seine Arbeit erscheint unter Arbeit bei dieser Anlage.",
maintenanceSave: "Plan erstellen",
maintenanceSuccessTitle: "Plan erstellt",
maintenanceSuccessBody: "Die Arbeit wird erzeugt, wenn der Plan fällig wird. Verwalten Sie ihn im Wartungs-Tab der Anlage.",
maintenanceHeading: "Wartungsplan",
maintenanceSub: "Arbeit, die wiederkommt – eine Wartung, eine Prüfung oder eine Inspektion. Wählen Sie die Anlage, sagen Sie, was erledigt wird und wann es fällig ist. Der Auftrag erscheint bei jeder Fälligkeit unter Arbeit.",
modeWhenDue: "Wenn fällig",
repeatEvery: "Nach Datum wiederholen",
everyCount: "Alle",
unit: {
hours: "Stunden",
days: "Tage",
weeks: "Wochen",
months: "Monate",
years: "Jahre",
},
edit: {
  loadFailed: "Dieser Plan konnte nicht geöffnet werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
heading: "Plan bearbeiten",
sub: "Änderungen gelten ab dem nächsten Durchlauf des Plans. Bereits erstellte Arbeit bleibt unverändert.",
save: "Änderungen speichern",
savedTitle: "Plan aktualisiert",
savedBody: "Die Änderung gilt ab dem nächsten Durchlauf des Plans. Bereits erstellte Arbeit bleibt unverändert.",
notFound: "Dieser Plan konnte nicht gefunden werden. Er wurde möglicherweise beendet.",
conflict: "Jemand anderes hat diesen Plan gespeichert, nachdem Sie ihn geöffnet haben. Ihre Änderungen wurden nicht übernommen – gehen Sie zurück, öffnen Sie ihn erneut und nehmen Sie sie noch einmal vor.",
},
meterEvery: "Nach Zählerstand wiederholen",
meterInterval: "Alle",
meterKind: {
mileage: "Kilometerstand",
operating_hours: "Stunden",
cycles: "Zyklen",
},
meterCurrent: "Der Zähler zeigt derzeit {{amount}}.",
meterNoReading: "Noch kein Zählerstand — erfassen Sie einen bei der Anlage, damit der Plan eine Grundlage zum Zählen hat.",
whicheverFirst: "Je nachdem, was zuerst eintritt",
lastDone: "Zuletzt erledigt (optional)",
lastDoneDate: "Datum",
lastDoneTime: "Uhrzeit",
lastDoneMeter: "Zählerstand bei letzter Wartung",
lastDoneHint: "Leer lassen, um ab heute und dem aktuellen Zählerstand zu zählen.",
moreOptions: "Weitere Optionen",
meterAlso: "Auch nach Zählerstand wiederholen",
meterRemove: "Zählerwiederholung entfernen",
unitPickerTitle: "Wiederholen alle",
lastDoneHintNow: "Leer lassen, wenn noch nie erledigt.",
whoDoesIt: "Wer erledigt es (optional)",
nobodyYet: "Jedes Mal entscheiden",
whoDoesItHint: "Jeder Termin geht an {{name}}, der benachrichtigt wird, sobald er ansteht.",
nobodyYetHint: "Jeder Termin erscheint bis zu zwei Wochen vor der Fälligkeit, und Sie werden gebeten, ihn zuzuweisen – mit einer Erinnerung 3 Tage vorher.",
assetPlaceholder: "Anlage wählen",
firstRunDatePlaceholder: "Datum",
firstRunTimePlaceholder: "Uhrzeit",
ok: "OK",
unsavedGuard: {
editMessage: "Ihre Änderungen an diesem Plan werden nicht gespeichert. Gehen und sie verlieren?",
createMessage: "Dieser Plan ist noch nicht gespeichert. Verlassen und verwerfen?",
discard: "Verlassen",
keep: "Bearbeiten Sie weiter",
},
doItAs: "Ausführen als",
asJob: "Auftrag",
asInspection: "Inspektion",
pickTemplate: "Checkliste auswählen",
serviceReading: "Zählerstand bei der Wartung",
useReading: "{{amount}} als Wartungszählerstand verwenden",
heading: "Wartungsplan",
sub: "Legt den nächsten Auftrag automatisch nach Zeitplan an – nach Abschluss des vorigen oder zum Kalendertermin.",
asset: "Anlage",
title: "Was erledigt wird",
titlePh: "z. B. Jahreswartung",
description: "Einzelheiten (optional)",
descriptionPh: "Was jedes Mal zu tun ist",
category: "Kategorie",
firstRun: "Erster Durchlauf (Datum & Uhrzeit)",
recurrence: "Wiederholung",
advanceMode: "Wie soll der nächste Auftrag erstellt werden?",
modeCompletion: "Nach Abschluss des vorherigen Auftrags",
modeCalendar: "Am Kalenderfälligkeitsdatum",
modeHint: {
when_due: "Der nächste Auftrag erscheint, wenn das Datum oder der Zähler es anzeigt — je nachdem, was zuerst eintritt. Bis dahin wird nichts erstellt.",
on_completion: "Der nächste Auftrag erscheint, nachdem Sie den aktuellen in dieser Serie abgeschlossen oder abgebrochen haben.",
on_calendar: "Ein neuer Auftrag wird erstellt, sobald jedes Fälligkeitsdatum eintritt — auch wenn der vorherige Auftrag noch offen ist (sofern Sie unten nicht das Überspringen aktivieren).",
},
skipIfPriorOpen: "Den nächsten auslassen, wenn der letzte noch offen ist",
seriesLimits: "Wiederholung beenden (optional)",
seriesLimitsHint: "Lassen Sie beide Felder leer, damit es sich weiter wiederholt.",
endDate: "Enddatum",
endTime: "Endzeit",
checksHint: "Wird jedem Auftrag hinzugefügt, den dieser Plan erstellt.",
maxJobs: "Nach so vielen Aufträgen beenden",
maxPh: "Keine Begrenzung",
save: "Serie erstellen",
saving: "Wird erstellt…",
successTitle: "Serie erstellt",
successBody: "Der erste Auftrag steht unter Arbeit; die nächsten folgen Ihrem Zeitplan.",
errorTitle: "Plan nicht gespeichert",
footer: "Anlage: {{asset}}",
errors: {
  meterNowFailed: "Dieser Zählerstand konnte nicht gespeichert werden. Prüfen Sie die Zahl und versuchen Sie es erneut.",
  meterNow: "Geben Sie den aktuellen Zählerstand ein.",
every: "Geben Sie an, wie oft, als ganze Zahl.",
meter: "Geben Sie an, wie oft, in {{unit}}.",
noLeg: "Fügen Sie eine Wiederholung nach Datum, nach Zähler oder beides hinzu.",
template: "Wählen Sie eine Checkliste für die Inspektion aus.",
lastDone: "Wählen Sie ein gültiges Datum für „zuletzt erledigt“ oder lassen Sie es leer.",
lastDoneMeter: "Geben Sie den Zählerstand bei der letzten Wartung ein oder lassen Sie ihn leer.",
readingLower: "Der Wartungszählerstand ist niedriger als der aktuelle Wert {{amount}}.",
asset: "Wählen Sie die Anlage für diesen Plan.",
title: "Geben Sie an, was erledigt wird.",
datetime: "Wählen Sie ein gültiges Datum und eine gültige Uhrzeit für den ersten Durchlauf.",
endInvalid: "Wählen Sie ein gültiges Enddatum.",
endBeforeStart: "Das Enddatum muss am oder nach dem ersten Termin liegen.",
max: "Geben Sie die Anzahl der Aufträge ein oder lassen Sie das Feld leer.",
generic: "Ihr Plan wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
},
serviceReadingHint: "Die nächste Wartung wird ab diesem Zählerstand gerechnet.",
dueBy: "Wann ist es fällig?",
trigger: {
  schedule: "Alle…",
  fixed_date: "An festen Terminen",
  document_renewal: "Wenn ein Dokument abläuft",
  condition: "Wenn der Zustand sinkt",
  manual: "Kein Zeitplan, ich starte ihn",
},
triggerHint: {
  fixed_date: "An jedem Termin wird Arbeit erzeugt.",
  document_renewal: "Arbeit wird erzeugt, wenn das Dokument abläuft. Wird die Verlängerung abgelegt, springt der Plan auf das neue Ablaufdatum.",
  condition: "Arbeit wird erzeugt, wenn der Zustandswert der Anlage auf diesen Wert oder darunter fällt.",
  manual: "Von selbst wird nichts erzeugt. Starten Sie ihn bei Bedarf im Wartungs-Tab der Anlage.",
},
dates: "Termine",
addDate: "Termin hinzufügen",
removeDate: "Diesen Termin entfernen",
pickDocument: "Dokument auswählen",
documentExpires: "{{title}} · läuft ab am {{when}}",
noDocuments: "Diese Anlage hat noch kein Dokument mit Ablaufdatum. Fügen Sie eines hinzu und wählen Sie es dann hier aus.",
conditionScore: "Zustandswert (0–100)",
errorDates: "Fügen Sie mindestens einen Termin hinzu.",
errorDocument: "Wählen Sie das Dokument, dessen Ablauf den Plan fällig macht.",
errorCondition: "Geben Sie einen Zustandswert von 0 bis 100 ein.",
},
handoff: {
  couldNotLoadTeam: "Das Team konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und tippen Sie auf Wiederholen.",
  assignToMyself: "Mir selbst zuweisen",
  inviteTeammate: "Teammitglied einladen",
  createdSubtitleAssigned: "Er ist jetzt unter Arbeit und {{name}} zugewiesen. Wählen Sie ein Datum, sobald er angenommen wurde.",
  createdSubtitle: "Er ist jetzt unter Arbeit. Wählen Sie, wer ihn übernimmt und wann. Die Person wird benachrichtigt, sobald Sie ihn zuweisen.",
  createdTitle: "Auftrag erstellt",
  assignTitle_other: "Aufträge zuweisen",
  assignTitle_one: "Auftrag zuweisen",
pageTitle: "Auftrag zuweisen",
releaseFollowUpTitle: "Folgeauftrag genehmigen",
releaseSubtitle: "Genehmigen Sie ihn, wählen Sie, wer ihn übernimmt, und legen Sie ein Datum fest.",
batchSubtitle: "Wählen Sie für jeden Auftrag, wer ihn übernimmt und wann. Die Personen werden benachrichtigt, sobald Sie zuweisen.",
emptyTitle: "Keine Aufträge zum Zuweisen",
emptyBody: "Hier gibt es keine Aufträge zum Zuweisen. Gehen Sie zurück zu Arbeit, um neue zu finden.",
backToWork: "Zurück zu Arbeit",
releaseHandoffTitle: "Genehmigen und zuweisen",
smoothHandoffTitle: "Jeden Auftrag zuweisen",
releaseIntroText: "Jede Karte zeigt, wer die Arbeit angefragt hat, wer sie erledigt, wann, und wer den fertigen Bericht erhält. Nach der Genehmigung kann er zugewiesen und terminiert werden.",
batchIntroText: "Jede Karte zeigt, wer die Arbeit angefragt hat, wer sie erledigt, wann, und wer den fertigen Bericht erhält. Nach einer Zuweisung erscheint der nächste.",
applyToAllJobs: "Auf alle {{count}} Arbeitsaufträge anwenden",
scheduleAllJobsTogether: "Planen Sie alle Arbeitsaufträge zusammen",
scheduleTogether: "Gemeinsam planen",
setWorkPathToAllJobs: "Für alle Aufträge: {{mode}}",
allInternal: "Alle an unser Team",
allToContractor: "Alle an einen Auftragnehmer",
allToQuotes: "Für alle Angebote einholen",
pendingRelease: "Genehmigung nötig",
requester: "Antragsteller",
noRequesterLinked: "Noch kein Anfragender verlinkt",
requesterNoneLinked: "Kein Anfragender verknüpft, daher erhält nur Ihr Team den Bericht.",
assigneeLine: "Zuständige Person: {{name}}",
setOnRelease: "Wird bei Genehmigung gewählt",
verbAssignToTeam: "dem Team zuweisen",
verbAssignToContractor: "dem Auftragnehmer zuweisen",
verbRequestQuotes: "Angebote anfordern",
approveAndVerb: "Genehmigen und {{verb}}",
changeAssignee: "Zuständige Person ändern",
workPathLabel: "Wer übernimmt es?",
assigneeLabel: "Zuständige Person",
plannedDateLabel: "Geplantes Datum",
completionRecipientsLabel: "Wer den fertigen Bericht erhält",
requiredSkillsLabel: "Erforderliche Fähigkeiten",
notScheduledYet: "Noch nicht geplant",
awaitingAcceptance: "{{name}} · wartet auf Annahme",
notAssignedYet: "Noch nicht zugewiesen",
assignToName: "{{name}} zuweisen",
someoneElse: "Jemand anderes",
sourceContractorHint: "{{name}} hat den Auftrag erledigt, aus dem dieser stammt.",
awaitingNote: "Ein Datum ist möglich, sobald er angenommen wurde",
changeDate: "Datum ändern",
planDate: "Datum wählen",
viewJobLabel: "Arbeitsauftrag anzeigen {{title}}",
viewJob: "Auftrag anzeigen",
doneBackToRequest: "Fertig · Zurück zur Anfrage",
doneBackToAsset: "Fertig · Zurück zur Anlage",
doneBackToJobs: "Fertig · Zurück zu den Arbeitsaufträgen",
doneOpenJob: "Fertig · Arbeitsauftrag öffnen",
assignToTeamMemberTitle: "Einem Teammitglied zuweisen",
teamHintNoTeamAsset: "Diese Anlage ist nicht mit einem Team verknüpft – es gilt die persönliche Zuweisung. Sie können sich den Auftrag selbst zuweisen.",
teamHintNoTeamJob: "Für diesen Auftrag ist kein Team festgelegt – persönliche Zuweisung. Sie können sich den Auftrag selbst zuweisen.",
teamHintUsingTeam: "Verwendet wird das Team, das diesen Auftrag oder diese Anlage verwaltet: {{name}}",
teamHintUsingWorkspaceTeam: "Verwendet wird das Team des Arbeitsbereichs, das mit diesem Auftrag oder dieser Anlage verknüpft ist.",
loadingTeamMembers: "Teammitglieder werden geladen…",
retry: "Wiederholen",
noTeamMembersTitle: "Noch niemand sonst im Team",
noTeamMembersBody: "Fügen Sie ein Teammitglied hinzu, um ihm Arbeit zuzuweisen, oder weisen Sie sie sich selbst zu.",
refresh: "Aktualisieren",
unnamedMember: "Unbenanntes Mitglied",
youSuffix: " (Sie)",
scheduleJobsTogetherTitle: "{{count}} Arbeitsaufträge gemeinsam planen",
planHandoffDateTitle: "Wann wird er erledigt?",
scheduleTogetherText: "Auf jeden passenden Auftrag in dieser Auswahl werden dasselbe Datum, dieselbe Uhrzeit und dieselbe geschätzte Dauer angewendet.",
planHandoffDateText: "Wählen Sie Tag und Uhrzeit für die Arbeit.",
dateLabel: "Datum",
timeLabel: "Uhrzeit",
estimatedDurationLabel: "Geschätzte Dauer",
cancel: "Abbrechen",
saveForJobs: "Für {{count}} Arbeitsaufträge speichern",
saveDate: "Datum speichern",
chooseContractorsForQuotes: "Wählen Sie Auftragnehmer für Angebote aus",
assignToContractorTitle: "Dem Auftragnehmer zuweisen",
addContractor: "Auftragnehmer hinzufügen",
error: "Etwas ist schiefgelaufen",
failedApplyWorkPathAll: "Nicht alle Aufträge wurden geändert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedUpdateWorkPath: "Die Auswahl wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedAssign: "Der Auftrag wurde nicht zugewiesen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedReleaseFollowUp: "Der Folgeauftrag wurde nicht genehmigt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedScheduleJobsTogether: "Die Termine wurden nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
failedSchedule: "Das Datum wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
noTeamTitle: "Kein Team für diesen Auftrag",
noTeamBody: "Es war nicht erkennbar, zu welchem Team dieser Auftrag gehört; der Auftragnehmer wurde nicht eingeladen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
assignedTitle: "Zugewiesen, aber die E-Mail wurde nicht gesendet",
assignedInviteFailedBody: "Der Auftrag gehört jetzt ihm, aber die Einladung konnte nicht gesendet werden. Informieren Sie ihn selbst.",
plannedDateRequiredTitle: "Geplantes Datum erforderlich",
plannedDateRequiredBody: "Wählen Sie vor dem Speichern ein geplantes Datum.",
nothingToScheduleTitle: "Nichts zu planen",
nothingToScheduleBody: "In dieser Auswahl sind noch keine Aufträge zur Planung bereit.",
mustBeAcceptedError: "Der Auftrag muss angenommen sein, bevor Sie ein Datum wählen können.",
},
updates: {
  audienceEveryone: "Alle an diesem Auftrag",
  audienceTeam: "Nur mein Team",
  failedToPostUpdate: "Das Update wurde nicht veröffentlicht. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  failedToSend: "Ihr Update wurde nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  quickPosted: "Update veröffentlicht. Es erscheint in der Aktivität des Auftrags.",
  quick: {
    follow_up_required: {
      note: "Ein Folgeauftrag ist nötig.",
      label: "Folgeauftrag nötig",
    },
    completed_successfully: {
      note: "Die Arbeit ist erledigt.",
      label: "Arbeit erledigt",
    },
    additional_issue_found: {
      note: "Bei der Arbeit wurde ein weiteres Problem gefunden.",
      label: "Weiteres Problem gefunden",
    },
    awaiting_access: {
      note: "Kann nicht weitermachen: warte auf Zugang zum Standort.",
      label: "Warte auf Zugang",
    },
    awaiting_parts: {
      note: "Warte auf Teile, bevor die Arbeit weitergehen kann.",
      label: "Warte auf Teile",
    },
    work_in_progress: {
      note: "Arbeit läuft.",
      label: "Arbeit läuft",
    },
    arrived_on_site: {
      note: "Vor Ort angekommen.",
      label: "Vor Ort angekommen",
    },
  },
pageTitle: "Aktualisierungen",
jobFallback: "Auftrag",
suggestedUpdateTitle: "Vorgeschlagenes Update",
accept: "Annehmen",
expandedUpdate: "Erweitertes Update",
improvedUpdate: "Verbessertes Update",
unableToExpandNote: "Notiz kann nicht erweitert werden",
unableToImproveNote: "Notiz kann nicht verbessert werden",
reviewGeneratedWording: "Überprüfen Sie den generierten Wortlaut, bevor Sie ihn auf das Update anwenden.",
photoAccessRequiredTitle: "Fotozugriff erforderlich",
photoAccessRequiredBody: "Erlauben Sie den Zugriff auf die Fotobibliothek, um ein Bild anzuhängen.",
photoNotSavedTitle: "Foto wurde nicht gespeichert",
photoNotSavedFallback: "Dieses Foto konnte nicht auf dem Gerät gespeichert werden.",
activityLoadErrorTitle: "Aktivität konnte nicht geladen werden. Versuchen Sie es erneut.",
tryAgain: "Erneut versuchen",
loadingActivity: "Aktivität wird geladen",
emptyActivity: "Noch keine Aktivität. Hier werden Aktualisierungen, Kommentare, Zuweisungen und Statusänderungen angezeigt.",
internalBadge: "Intern",
savedOnThisDevice: "Auf diesem Gerät gespeichert",
showingRecentUpdates: "Zeigt die letzten 100 gespeicherten Updates an.",
showingSavedActivity: "Gespeicherte Aktivität wird angezeigt.",
lastRefreshed: "Zuletzt aktualisiert {{date}}. Fotos benötigen möglicherweise eine Verbindung.",
refreshActivity: "Aktivität aktualisieren",
refreshing: "Wird aktualisiert…",
quickUpdates: "Schnelle Updates",
attachPhoto: "Hängen Sie ein Foto an",
startUpdatePlaceholder: "Ein Update starten...",
jobUpdateLabel: "Arbeitsauftragsaktualisierung",
internalToggleOn: "Nur Ihr Team sieht diese Notiz, der Auftragnehmer nicht. Tippen Sie, um sie allen am Auftrag zu zeigen.",
internalToggleOff: "Alle am Auftrag sehen diese Notiz. Tippen Sie, um sie nur Ihrem Team zu zeigen.",
sendUpdate: "Update senden",
improving: "Verbesserung...",
improveNote: "Notiz verbessern",
expanding: "Wird ergänzt…",
expandNote: "Mit KI ergänzen",
aiCleanup: "KI-Bereinigung",
connectOnceHint: "Stellen Sie einmal eine Verbindung her, um diesen Arbeitsbereich zu öffnen, bevor Sie Aktualisierungen speichern.",
openingWorkspace: "Öffnen Ihres Arbeitsbereichs…",
updatesSavedOnDevice_one: "{{count}} Update auf diesem Gerät gespeichert.",
updatesSavedOnDevice_other: "{{count}} Updates auf diesem Gerät gespeichert.",
photosSavedOnDevice_one: "{{count}} Foto auf diesem Gerät gespeichert.",
photosSavedOnDevice_other: "{{count}} Fotos auf diesem Gerät gespeichert.",
syncNeedsAttention: "Synchronisierung erfordert Aufmerksamkeit.",
waitingToSynchronize: "Warten auf Synchronisierung.",
reviewSynchronization: "Überprüfen Sie die Synchronisierung",
syncFailed: "Nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
couldNotSyncActivity: "Die Arbeitsauftragsaktivität konnte nicht synchronisiert werden.",
jobPhoto: "Arbeitsauftragsfoto",
},
checkRunner: {
jobStarted: "Auftrag gestartet. Tippen Sie auf Abschließen, wenn die Arbeit erledigt ist.",
couldNotStartTitle: "Der Arbeitsauftrag konnte nicht gestartet werden",
tryAgain: "Versuchen Sie es erneut.",
checkFallbackTitle: "Prüfung",
stepWord_one: "Schritt",
stepWord_other: "Schritte",
jobStartsWhenDone: "Der Auftrag startet, sobald dies erledigt ist",
finishPrecheckAndStart: "Vorprüfung abschließen und Arbeitsauftrag starten",
doneBackToJob: "Fertig – zurück zum Arbeitsauftrag",
},
quotes: {
inclTax: "inkl. Steuern",
declinedLine: "{{name}} hat abgelehnt: {{reason}}",
pageTitle: "Angebote vergleichen",
inviteOnly: "Nur auf Einladung",
contractorFallback: "Auftragnehmer",
durationNotProvided: "Dauer nicht angegeben",
priceDeltaVsLowest: "+{{amount}} vs. niedrigster Wert",
durationDeltaVsFastest: "+{{duration}} vs. Schnellster",
compareQuotesAction: "Angebote vergleichen",
recommendOne: "Empfehlen Sie eines",
jobTitleFallback: "Angebotsanfrage",
jobNotFound: "Arbeitsauftrag nicht gefunden.",
awardQuoteConfirmTitle: "{{name}} beauftragen?",
priceDurationLine: "{{price}} | {{duration}}",
aiRecommendationFavors: "Die KI-Empfehlung bevorzugt derzeit dieses Angebot.",
awardConsequence: "Der Auftrag geht sofort an {{name}}. Alle anderen Angebote werden abgelehnt und diese Auftragnehmer benachrichtigt.",
awarded: "Angebot angenommen. Der Auftrag gehört jetzt {{name}}, und die anderen Auftragnehmer mit Angebot wurden benachrichtigt.",
acceptFailedTitle: "Angebot konnte nicht angenommen werden",
acceptFailedBody: "Das Angebot wurde nicht angenommen. Laden Sie diese Seite neu, um zu sehen, ob bereits entschieden wurde, und versuchen Sie es dann erneut.",
rejectFailedTitle: "Angebot konnte nicht abgelehnt werden",
rejectFailedBody: "Das Angebot wurde nicht abgelehnt. Laden Sie diese Seite neu und versuchen Sie es dann erneut.",
acceptQuoteFallbackMessage: "Dieses Angebot annehmen und den Auftrag mit Auftragnehmer, erwarteten Kosten und erwarteter Dauer aktualisieren?",
awardQuoteTitle: "Auftrag vergeben",
cancel: "Abbrechen",
award: "Vergeben",
error: "Fehler",
failedAcceptQuote: "Angebot konnte nicht angenommen werden",
rejectQuoteConfirmTitle: "Angebot von {{name}} ablehnen?",
decisionTrackedNotify: "Diese Entscheidung wird verfolgt und kann den Auftragnehmer benachrichtigen.",
rejectQuoteFallbackMessage: "Dieses Angebot ablehnen? Der Auftragnehmer kann benachrichtigt werden und diese Entscheidung wird nachverfolgt.",
rejectQuoteTitle: "Angebot ablehnen",
reject: "Ablehnen",
failedRejectQuote: "Angebot konnte nicht abgelehnt werden",
aiQuoteIntelligenceTitle: "KI-Angebotsanalyse",
aiGroundedHint: "Basiert nur auf den übermittelten Angebotsfeldern. Überprüfen Sie dies, bevor Sie eine endgültige Entscheidung treffen.",
generatingAiInsights: "Generierung von KI-Erkenntnissen...",
refreshAiInsights: "Aktualisieren Sie KI-Erkenntnisse",
generateAiInsights: "Generieren Sie KI-Erkenntnisse",
lastUpdated: "Letzte Aktualisierung: {{date}}",
comparisonInsightsLabel: "Vergleichseinblicke",
notableDifferencesLabel: "Bemerkenswerte Unterschiede",
bestValueSuggestionLabel: "Vorschlag mit dem besten Preis-Leistungs-Verhältnis (unterstützend)",
suggestedQuote: "Vorgeschlagenes Angebot: {{name}}",
noSingleQuoteSuggested: "Noch kein einzelnes Angebot vorgeschlagen (unzureichende Nachweise).",
cautionLine: "Achtung: {{caution}}",
confidenceLine: "Sicherheit: {{confidence}}",
unableToGenerateAiInsights: "Es können keine KI-Erkenntnisse generiert werden.",
comparisonSummaryLabel: "Angebote vergleichen",
priceRangeLine: "Preisspanne: {{low}} bis {{high}}",
priceDataUnavailable: "Preisdaten nicht verfügbar.",
durationRangeLine: "Dauerbereich: {{fast}} bis {{slow}}",
durationDataUnavailable: "Dauerdaten nicht verfügbar.",
jobContextLabel: "Arbeitsauftragskontext",
assetLine: "Anlage: {{name}}",
noLinkedAsset: "Keine verknüpfte Anlage",
locationLine: "Standort: {{value}}",
categoryLine: "Kategorie: {{value}}",
urgencyLine: "Dringlichkeit: {{value}}",
requestProgressLabel: "Fortschritt der Anfrage",
inviteSummaryLine: "{{invited}} eingeladen · {{submitted}} eingereicht · {{declined}} abgelehnt",
inviteSummaryPendingSuffix: " · {{pending}} ausstehend",
responseDeadlineLine: "Antwortfrist: {{date}}",
targetWindowLine: "Zielfenster: {{start}} bis {{end}}",
budgetLine: "Budget: {{value}}",
scopeLabel: "Leistungsumfang",
noOpenQuotesTitle: "Keine offenen Angebote zur Entscheidung",
noOpenQuotesBody: "Eingeladene Auftragnehmer können Angebote abgeben. Entscheidungen erscheinen hier.",
allDeclinedBody: "Alle Angefragten haben abgelehnt. Laden Sie weitere Auftragnehmer ein, um einen Preis zu erhalten.",
headerContractor: "Auftragnehmer",
headerPrice: "Preis",
headerDuration: "Dauer",
headerAvailability: "Verfügbarkeit",
headerScopeExclusions: "Leistungsumfang / Ausschlüsse",
headerAiSummary: "KI-Zusammenfassung",
scopeResponseMissing: "Antwort zum Leistungsumfang fehlt",
missingLine: "Fehlt: {{items}}",
completeResponse: "Vollständige Antwort",
bestPriceChip: "Bester Preis",
fastestChip: "Am schnellsten",
aiRecommendedChip: "Von KI empfohlen",
runAiInsightsToGenerateSummary: "Starten Sie die KI-Analyse, um eine Zusammenfassung zu erstellen.",
acceptedQuoteLabel: "Angenommenes Angebot",
rejectedQuotesLabel: "Abgelehnte Angebote",
reasonLine: "Grund: {{reason}}",
selectQuoteTitle: "Wählen Sie ein Angebot aus",
selectQuoteBody: "Wählen Sie eine Angebotszeile aus, um Details, KI-Einblicke und Vergabeentscheidungen zu prüfen.",
rejecting: "Wird abgelehnt...",
awarding: "Wird vergeben...",
awardQuoteAction: "Auftrag vergeben",
openJob: "Auftrag öffnen",
bestPriceAndFastest: "Bester Preis und am schnellsten",
fastestDuration: "Schnellste Dauer",
submittedQuoteStatus: "Angebot eingereicht",
applyingDecision: "Entscheidung wird angewendet…",
aiIntelligenceLabel: "KI-Intelligenz",
includedLabel: "Enthalten",
excludedLabel: "Ausgeschlossen",
caveatsLabel: "Vorbehalte",
aiSummaryIncludedLine: "Enthalten: {{items}}",
aiSummaryExcludedLine: "Ausgeschlossen: {{items}}",
aiSummaryCaveatsLine: "Vorbehalte: {{items}}",
recommendationLabel: "Empfehlung",
recommendationValue: "{{name}} ({{confidence}})",
noneFallback: "Keine",
whatsIncludedHeading: "Was ist enthalten",
notProvidedFallback: "Nicht bereitgestellt",
materialsLabel: "Materialien",
notIncludedFallback: "Nicht enthalten",
warrantyLabel: "Garantie",
availabilityRangeArrow: "{{start}} → {{end}}",
exclusionsLabel: "Ausschlüsse",
evidenceLabel: "Nachweis",
missingInfoLine: "Fehlende Informationen: {{items}}",
linkedContextHeading: "Verknüpfter Kontext",
jobLabelKv: "Auftrag",
assetLabelKv: "Anlage",
noScopeProvided: "Kein Leistungsumfang angegeben",
requestNotesLabel: "Notizen zur Anfrage",
noNotesProvided: "Keine Notizen bereitgestellt",
inviteMoreContractors: "Weitere Auftragnehmer einladen",
scopeResponseLine: "Umfang: {{value}}",
durationLine: "Dauer: {{value}}",
availabilityToLine: "Verfügbarkeit: {{start}} bis {{end}}",
exclusionsLine: "Enthält: {{value}}",
evidenceLine: "Nachweis: {{value}}",
warrantyLine: "Garantie: {{value}}",
attachmentsLine: "Anhänge: {{count}}",
aiSummaryLabel: "KI-Zusammenfassung",
fastestDurationChip: "Schnellste Dauer",
acceptQuote: "Angebot annehmen",
},
share: {
  relationshipChangeA11y: "Beziehung zum Objekt ändern",
  relationshipChange: "Ändern",
  relationship: "Beziehung: {{role}}",
  openJob: "Auftrag öffnen",
  editContactDetails: "Kontaktdaten bearbeiten",
  copyLink: "Link kopieren",
  emailNotSent: "Geteilt, aber die E-Mail wurde nicht gesendet. Kopieren Sie den Link und senden Sie ihn selbst.",
  checkDetails: "Prüfen Sie Kontakt, Rolle und E-Mail und tippen Sie erneut auf Senden.",
  emailRequired: "Geben Sie die E-Mail-Adresse ein. Der Link zum Bericht wird dorthin gesendet.",
  roleRequired: "Wählen Sie, wer die Person ist, zum Beispiel Anfragender.",
  addEmail: "E-Mail hinzufügen",
  chooseRole: "Rolle wählen",
  chooseContact: "Kontakt wählen",
jobFallback: "Auftrag",
couldNotLoadReport: "Dieser Bericht konnte nicht geladen werden. Versuchen Sie es erneut.",
greetingDefault: "Hallo,\n\nHier finden Sie den Arbeitsauftragsabschlussbericht für {{name}}. Die Arbeiten sind abgeschlossen und für Ihre Unterlagen dokumentiert.\n\nVielen Dank.",
loadingReport: "Bericht wird geladen",
tryAgain: "Erneut versuchen",
jobNotFound: "Arbeitsauftrag nicht gefunden",
onlyOwnerCanShare: "Nur der Arbeitsauftragseigentümer oder ein Mitglied des Anlagenteams kann den Abschlussbericht teilen.",
goBack: "Zurück",
completeAndVerifyFirst: "Schließen Sie diesen Auftrag ab, bevor Sie seinen Bericht teilen.",
error: "Fehler",
jobNotFoundBody: "Arbeitsauftrag nicht gefunden.",
notReadyTitle: "Nicht bereit",
notReadyBody: "Schließen Sie diesen Auftrag ab, bevor Sie seinen Bericht teilen.",
checkPhoneTitle: "Telefonnummer prüfen",
checkPhoneBody: "Geben Sie eine gültige Nummer für das gewählte Land ein oder lassen Sie das Feld leer.",
resent: "Erneut gesendet",
sent: "Gesendet",
resentBody: "Bericht erneut gesendet. Die Person erhält eine neue E-Mail mit dem Link.",
sentBody: "Bericht gesendet. Die Person erhält eine E-Mail mit einem Link zur Arbeit.",
emailErrorLine: "\n\nFehler: {{error}}",
emailFailedBody: "Die E-Mail konnte nicht gesendet werden. Teilen Sie den Link zum Bericht manuell:\n{{link}}{{errorLine}}",
shareCreatedTitle: "Freigabe erstellt",
shareCreatedBody: "Teilen Sie diesen Link:\n{{link}}",
failedToCreateShare: "Der Bericht wurde nicht geteilt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
devLinkWarning: "Freigabelinks verwenden localhost und funktionieren nicht für Empfänger. Fügen Sie EXPO_PUBLIC_WEB_APP_URL zu Ihrer .env (Ihrer bereitgestellten App URL) hinzu und starten Sie neu.",
prodLinkWarning: "Für diesen Arbeitsbereich ist noch kein gemeinsam nutzbarer Weblink eingerichtet, sodass Empfänger den Berichtslink möglicherweise nicht öffnen können. Bitte wenden Sie sich an Ihren Administrator.",
shareToLabel: "Senden an",
shareToHint: "Tippen Sie auf Kontakt auswählen und wählen Sie die Person. Personen, an die Sie ihn schon gesendet haben, stehen oben.",
whoCanOpen: "Nur diese Person kann den Bericht öffnen. Der Link in ihrer E-Mail meldet sie direkt an. Wer den Link sonst bekommt, kann Sie nur um Zugriff bitten.",
changeContact: "Kontakt ändern",
selectContact: "Kontakt auswählen",
contactFallback: "Kontakt",
noEmailOrPhone: "Keine E-Mail oder Telefon",
shareToContactTitle: "Senden an",
howToSendLabel: "So senden Sie",
shareViaLabel: "Teilen über",
emailMethodLabel: "E-Mail",
roleLabel: "Rolle *",
recipientNameLabel: "Name der Person (optional)",
recipientNamePlaceholder: "z.B. John Smith",
recipientEmailLabel: "E-Mail-Adresse *",
recipientEmailAria: "E-Mail-Adresse (Pflichtfeld)",
recipientEmailPlaceholder: "client@example.com",
phoneOptionalLabel: "Telefon (optional)",
shareStatusLabel: "Bereits gesendet",
firstSharedLine: "Bereits gesendet am {{date}}",
lastResharedLine: "Erneut gesendet am {{date}}",
noResponseByDeadline: "Keine Antwort bis zum festgelegten Datum. Tippen Sie auf Erneut senden, um zu erinnern.",
responseDeadlineLabel: "Antwort bis (optional)",
selectDatePlaceholder: "Datum wählen",
messageOptionalLabel: "Nachricht (optional)",
messagePlaceholder: "Fügen Sie eine Notiz für den Empfänger hinzu...",
actualCostOnReport: "Tatsächliche Kosten im Bericht: {{amount}}",
sending: "Wird gesendet…",
resend: "Erneut senden",
send: "Bericht senden",
cancel: "Abbrechen",
couldNotShareReportTitle: "Bericht konnte nicht geteilt werden",
sharingFailedFallback: "Freigabe fehlgeschlagen. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
},
requestQuotes: {
includedItemsHeading: "Enthaltene Leistungen:",
excludedOrAssumptionsHeading: "Ausgeschlossen oder Annahmen:",
clarificationQuestionsHeading: "Klärungsfragen:",
addNotesFirstTitle: "Zuerst Notizen hinzufügen",
addNotesFirstBody: "Geben Sie Notizen ein oder diktieren Sie sie und verwenden Sie dann KI, um sie neu zu schreiben.",
couldNotRewriteNotesTitle: "Notizen konnten nicht neu geschrieben werden",
tryAgain: "Bitte erneut versuchen.",
applyAiScopeDraftTitle: "KI-Entwurf zum Leistungsumfang übernehmen",
applyAiScopeDraftBody: "Sie haben bereits einen Text zum Leistungsumfang. Ersetzen oder den KI-Entwurf anhängen?",
cancel: "Abbrechen",
append: "Anhängen",
replace: "Ersetzen",
unableToGenerateScopeTitle: "Leistungsumfang konnte nicht erstellt werden",
selectContractorsTitle: "Wählen Sie Auftragnehmer aus",
selectContractorsBody: "Wählen Sie mindestens einen Auftragnehmer zum Einladen aus.",
quoteRequestSent_one: "Angebotsanfrage an {{count}} Auftragnehmer gesendet. Sie werden benachrichtigt, sobald Angebote eingehen. Vergleichen Sie sie in diesem Auftrag.",
quoteRequestSent_other: "Angebotsanfrage an {{count}} Auftragnehmer gesendet. Sie werden benachrichtigt, sobald Angebote eingehen. Vergleichen Sie sie in diesem Auftrag.",
error: "Fehler",
failedToSendQuoteRequest: "Angebotsanfrage konnte nicht gesendet werden",
sendFailedTitle: "Angebotsanfrage konnte nicht gesendet werden",
sendFailedBody: "Die Angebotsanfrage wurde nicht gesendet. Ihre Eingaben sind noch da – versuchen Sie es gleich noch einmal.",
noEmailNote: "Keine E-Mail-Adresse, daher erhält diese Person nichts. Fügen Sie auf der Kontaktseite eine hinzu.",
jobNotFound: "Arbeitsauftrag nicht gefunden.",
notPrivateQuotesBody: "Dieser Auftrag geht an eine einzelne Person. Um mehrere Auftragnehmer nach einem Preis zu fragen, tippen Sie auf Stattdessen Angebote einholen.",
notPrivateQuotesLockedBody: "Dieser Auftrag geht an eine einzelne Person und kann jetzt nicht mehr ausgeschrieben werden.",
switchToQuotes: "Stattdessen Angebote einholen",
switchingToQuotes: "Wird umgestellt…",
switchFailedTitle: "Umstellung auf Angebote nicht möglich",
switchFailedBody: "Der Auftrag wurde nicht geändert. Versuchen Sie es gleich noch einmal.",
backToJob: "Zurück zum Auftrag",
goBack: "Zurück",
jobTitleFallback: "Angebotsanfrage",
pageTitle: "Angebote anfordern",
inviteOnly: "Nur auf Einladung",
inviteTrustedHint: "Laden Sie vertrauenswürdige Auftragnehmer aus Ihrem Verzeichnis ein. Dies ist keine öffentliche Auflistung.",
scopeDescriptionLabel: "Leistungsumfang / Beschreibung",
scopeDescriptionPlaceholder: "Welche Arbeiten sind erforderlich?",
generatingScope: "Generieren...",
aiScope: "Mit KI formulieren",
notesOptionalLabel: "Notizen (optional)",
notesOptionalPlaceholder: "Zusätzlicher Kontext für Auftragnehmer",
rewriting: "Umschreiben...",
rewrite: "Neu schreiben",
aiScopeDraftDetailsTitle: "Details zum KI-Entwurf des Leistungsumfangs",
includedLine: "Enthalten: {{items}}",
excludedLine: "Ausgeschlossen: {{items}}",
questionsLine: "Fragen: {{items}}",
responseDeadlineLabel: "Antwortfrist (optional)",
respondByPlaceholder: "Bis wann sollten sie antworten?",
responseTimeLabel: "Uhrzeit der Antwortfrist (optional)",
selectTimePlaceholder: "Uhrzeit auswählen",
targetStartLabel: "Zielstart (optional)",
earliestStartPlaceholder: "Frühestes Startdatum",
targetEndLabel: "Zielende (optional)",
latestEndPlaceholder: "Spätestes Enddatum",
estimatedBudgetLabel: "Geschätztes Budget (optional)",
photosLabel: "Fotos (optional, max. 3)",
selectContractorsLabel: "Wählen Sie die einzuladenden Auftragnehmer aus *",
selectContractorsHint: "Durchsuchen Sie Ihre Kontakte und filtern Sie optional nach Fähigkeiten oder Umfang. Für Sie ist niemand vorab ausgewählt.",
requiredSkillsLabel: "Erforderliche Fähigkeiten",
addOrChangeContractors: "Auftragnehmer hinzufügen oder ändern",
chooseContractors: "Wählen Sie Auftragnehmer",
selectedCount: "Ausgewählt · {{count}}",
declinedToQuote: "Angebotsabgabe abgelehnt",
quoteSubmitted: "Angebot eingereicht",
alreadyInvited: "Bereits eingeladen – Antwort ausstehend",
removeContact: "{{name}} entfernen",
noContractorsSelected: "Noch keine Auftragnehmer ausgewählt.",
creating: "Wird erstellt…",
sending: "Wird gesendet…",
everyoneAlreadyInvited: "Alle ausgewählten Personen sind bereits eingeladen",
sendToMore_one: "An {{count}} weiteren Auftragnehmer senden",
sendToMore_other: "An {{count}} weitere Auftragnehmer senden",
sendTo_one: "An {{count}} Auftragnehmer senden",
sendTo_other: "An {{count}} Auftragnehmer senden",
chooseContractorsForQuotesTitle: "Wählen Sie Auftragnehmer für Angebote aus",
addContractor: "Auftragnehmer hinzufügen",
},
quoteInvite: {
brief: {
forClient: "Für {{name}}",
replyBy: "Antwort bis {{date}}",
budget: "Kostenrahmen {{amount}}",
starts: "Beginn {{date}}",
finishBy: "Fertig bis {{date}}",
due: "Fällig {{date}}",
whatTheyNeed: "Was gebraucht wird",
where: "Ort",
route: "Route mit Google Maps",
photos: "Ihre Fotos",
},
form: {
title: "Ihr Angebot",
intro: "Sagen Sie, was Ihr Preis abdeckt, dann den Gesamtbetrag. Vor dem Senden prüfen Sie alles.",
included: "Was enthalten ist",
labourOnly: "Nur Arbeitsleistung",
labourAndMaterials: "Arbeit und Material",
coversLabel: "Was Ihr Preis abdeckt",
coversPlaceholder: "z. B. Neues 3-Sitzer-Sofa liefern und aufstellen, altes entsorgen",
total: "Gesamtpreis",
totalTax: "inkl. aller Steuern",
totalHelp: "Mehrwertsteuer und alle anderen Steuern einrechnen: Das zahlt der Kunde.",
warranty: "Gewährleistung",
warrantyNone: "Keine",
warranty3: "3 Monate",
warranty6: "6 Monate",
warranty12: "12 Monate",
warrantyPlaceholder: "Oder Ihre eigene, z. B. 2 Jahre auf Teile",
takes: "Wie lange es dauert",
when: "Wann Sie es erledigen könnten",
earliest: "Frühester Beginn",
finishBy: "Fertig bis",
files: "Fotos oder Dokumente",
note: "Hinweis für den Kunden (optional)",
notePlaceholder: "Was er sonst noch wissen sollte",
review: "Prüfen und senden",
needPrice: "Geben Sie Ihren Gesamtpreis ein, um fortzufahren.",
cantQuote: "Kein Angebot für diesen Auftrag",
},
review: {
title: "Dieses Angebot senden?",
subtitle: "An {{name}}",
subtitleNoName: "An den Kunden",
total: "Gesamt, inkl. aller Steuern",
includes: "Enthält",
warranty: "Gewährleistung",
takes: "Dauer",
available: "Verfügbar",
files: "Anhänge",
filesCount: "{{n}} angehängt",
note: "Hinweis",
send: "Angebot senden",
change: "Etwas ändern",
from: "Ab {{date}}",
until: "Bis {{date}}",
},
declineSheet: {
title: "Kein Angebot für diesen Auftrag?",
subtitle: "Sagen Sie {{name}}, warum. Der Grund wird angezeigt.",
subtitleNoName: "Sagen Sie dem Kunden, warum. Der Grund wird angezeigt.",
reasonLabel: "Warum nicht?",
no_availability: "Keine Kapazität",
outside_area: "Außerhalb meines Gebiets",
not_my_work: "Nicht meine Art von Arbeit",
budget_or_timing: "Budget oder Zeitplan passen nicht",
other: "Etwas anderes",
noteLabel: "Noch etwas hinzufügen (optional)",
noteLabelOther: "Sagen Sie warum",
notePlaceholder: "z. B. Bis Dezember ausgebucht",
send: "Angebot ablehnen",
chooseReason: "Wählen Sie einen Grund, um fortzufahren.",
},
jobFallback: "Auftrag",
loadFailed: "Diese Angebotsanfrage wurde nicht geladen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
contextLoadFailed: "Die Details dieser Angebotsanfrage wurden nicht geladen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
notFound: "Diese Angebotsanfrage wurde nicht gefunden oder bereits beantwortet.",
alreadySent: "Sie haben für diese Anfrage bereits ein Angebot gesendet.",
alreadyDeclined: "Sie haben diese Angebotsanfrage abgelehnt.",
closedBody: "Diese Angebotsanfrage ist geschlossen. Der Kunde hat ein Angebot gewählt, die Frist ist abgelaufen oder die Anfrage wurde zurückgezogen.",
deadlinePassed: "Die Frist für diese Anfrage war {{date}}, daher kann der Kunde kein Angebot mehr annehmen.",
addNotesFirstTitle: "Zuerst Notizen hinzufügen",
addNotesFirstBody: "Tippen oder diktieren Sie Notizen und tippen Sie dann auf Umschreiben.",
rewriteFailedTitle: "Notizen konnten nicht umgeschrieben werden",
rewriteFailedBody: "Bitte versuchen Sie es erneut.",
enterPriceTitle: "Preis eingeben",
enterPriceBody: "Geben Sie den Gesamtpreis für diese Arbeit ein und tippen Sie dann auf Angebot senden.",
durationTitle: "Zeitschätzung prüfen",
durationBody: "Geben Sie eine Zahl größer als null ein oder lassen Sie das Feld leer.",
durationPlaceholder: "z. B. 2",
unit: {
hours: "Stunden",
days: "Tage",
weeks: "Wochen",
},
dictate: "Diktieren",
stop: "Stopp",
rewrite: "Umschreiben",
rewriting: "Wird umgeschrieben…",
submit: "Angebot senden",
submitting: "Wird gesendet…",
sent: "Angebot gesendet. Wir sagen Ihnen Bescheid, wenn der Kunde es annimmt.",
sendFailedTitle: "Ihr Angebot konnte nicht gesendet werden",
sendFailedBody: "Ihr Angebot wurde nicht gesendet. Ihre Eingaben sind noch da – versuchen Sie es gleich noch einmal.",
offlineSend: "Sie sind offline. Ihr Angebot bleibt auf diesem Gerät gespeichert – senden Sie es, sobald Sie wieder online sind.",
declineConfirmTitle: "Diese Anfrage ablehnen?",
declineConfirmBody: "Der Kunde erfährt, dass Sie kein Angebot abgeben.",
cancel: "Abbrechen",
decline: "Ablehnen",
declined: "Anfrage abgelehnt. Der Kunde wurde benachrichtigt.",
declineFailedTitle: "Ablehnen nicht möglich",
declineFailedBody: "Die Anfrage wurde nicht abgelehnt. Versuchen Sie es gleich noch einmal.",
offlineDecline: "Sie sind offline. Lehnen Sie die Anfrage ab, sobald Sie wieder online sind.",
},
contractorNotTold: {
title: "Niemand wurde benachrichtigt",
body: "{{name}} ist zugewiesen, hat aber keine E-Mail-Adresse und wurde daher nicht benachrichtigt. Fügen Sie die E-Mail-Adresse hinzu und weisen Sie erneut zu.",
},
created: {
  assignNow_other: "Jetzt zuweisen",
  assignNow_one: "Jetzt zuweisen",
  subtitleAssignedTo: "In der Arbeitsliste und {{names}} zugewiesen.",
  subtitleAssigned: "In der Arbeitsliste und zugewiesen.",
  changeWho: "Zuständigkeit ändern",
  subtitleSolo_other: "Die Aufträge sind unter Arbeit und Ihnen zugewiesen.",
  subtitleSolo_one: "Er ist unter Arbeit und Ihnen zugewiesen.",
  subtitle_other: "Die Aufträge sind unter Arbeit und nicht zugewiesen. Bisher wurde niemand benachrichtigt.",
  subtitle_one: "Er ist unter Arbeit und nicht zugewiesen. Bisher wurde niemand benachrichtigt.",
title_one: "{{count}} Auftrag erstellt",
title_other: "{{count}} Aufträge erstellt",
subtitle: "Die Aufträge sind unter Arbeit und nicht zugewiesen. Bisher wurde niemand benachrichtigt.",
listTitle: "Erstellte Aufträge",
jobLink: "Auftrag {{shortId}}",
backToRequest: "Zurück zur Anfrage",
backToAsset: "Zurück zur Anlage",
backToJobs: "Zurück zu Aufträgen",
technicalTitle: "Technische Details",
technicalSummary: "Vollständige Auftrags- und Anlagenkennungen für Support oder Schnittstellen.",
technicalJobIds: "Auftrags-IDs",
technicalAssetId: "Anlagen-ID",
showMore: "Mehr anzeigen",
showLess: "Weniger anzeigen",
},
jobTags: {
urgency: {
low: "Niedrige Priorität",
medium: "Mittlere Priorität",
high: "Hohe Priorität",
urgent: "Dringend",
critical: "Kritisch",
},
visibility: {
private: "Privat",
team: "Team",
public: "Öffentlich",
},
},
assigneeSuggestion: {
similarCompleted_one: "{{count}} ähnlicher abgeschlossener Auftrag",
similarCompleted_other: "{{count}} ähnliche abgeschlossene Aufträge",
skillMatches_one: "{{count}} Auftrag mit passenden erforderlichen Fähigkeiten",
skillMatches_other: "{{count}} Aufträge mit passenden erforderlichen Fähigkeiten",
completedOnAsset_one: "{{count}} an dieser Anlage abgeschlossen",
completedOnAsset_other: "{{count}} an dieser Anlage abgeschlossen",
activeAssignments_one: "{{count}} aktive Zuweisung",
activeAssignments_other: "{{count}} aktive Zuweisungen",
overdue_one: "{{count}} überfällig",
overdue_other: "{{count}} überfällig",
separator: ", ",
},
quoteComparisonCopy: {
materialsIncluded: "Material inbegriffen; keine Ausschlüsse angegeben",
materialsExcluded: "Material ausgeschlossen: {{details}}",
materialsMissing: "Material ausgeschlossen; Details fehlen",
evidenceAttachments_one: "{{count}} Nachweis angehängt",
evidenceAttachments_other: "{{count}} Nachweise angehängt",
noEvidence: "Keine Nachweise angehängt",
missingScope: "was der Preis abdeckt",
missingTiming: "Zeitplan",
durationHours_one: "{{count}} Stunde",
durationHours_other: "{{count}} Stunden",
durationDays_one: "{{count}} Tag",
durationDays_other: "{{count}} Tage",
durationWeeks_one: "{{count}} Woche",
durationWeeks_other: "{{count}} Wochen",
},
};
